// Copyright (c) 2016 Deere & Company

export default Object.freeze({
  A_LAYOUT_WITH_THAT_NAME_ALREADY_EXISTS: "Bu ada sahip bir mizanpaj zaten var",
  ACCEPT: "Kabul Et",
  ACCEPT_ALL: "T\xFCm\xFCn\xFC Kabul Et",
  ACCEPT_REJECT_TRANSFER_PENDING: "Onay Bekliyor",
  ACCEPTED: "Kabul Edildi",
  ACCOUNT: "Hesap",
  ACCOUNT_ADDRESS: "Hesap Adresi",
  ACCOUNT_COUNTRY: "Hesap \xDClkesi",
  ACCOUNT_END: "Hesap Sonu",
  ACCOUNT_NAME: "Hesap Ad\u0131",
  ACCOUNT_NUMBER: "Hesap Numaras\u0131",
  ACCOUNT_NUMBER_REQUIRED: "Gerekli Hesap Numaras\u0131",
  ACCOUNTS: "Hesaplar",
  ACCUMULATED_DAYS_ON_RENT: "Kiralamada Birikmi\u015F G\xFCn Say\u0131s\u0131",
  ACCUMULATED_DAYS_RENTED: "Kiralanmi\u015F Birikmi\u015F G\xFCn Say\u0131s\u0131",
  ACTIONS: "Eylemler",
  ACTIVE_WARRANTY: "Aktif Garanti",
  ACTIVE_WARRANTY_CLICK_FOR_DETAIL: "Aktif Garanti (Ayr\u0131nt\u0131lar i\xE7in t\u0131klay\u0131n)",
  ACTUAL_AUDIT: "Ger\xE7ek Denetim",
  ACTUAL_AUDIT_DATE: "Ger\xE7ek Denetim Tarihi",
  ACTUAL_COURIER_NAME: "Ge\xE7erli Kurye Ad\u0131",
  ACTUAL_HOURS: "Fiili Saat",
  ADD_CLAIM: "\u0130ddia Ekle",
  ADD_CLAIMS: "\u0130ddialar Ekle",
  ADD_COMPONENT: "Bile\u015Fen Ekle",
  ADD_OPTION: "Se\xE7enek Ekle",
  ADD_REP: "Ek Onar\u0131m",
  ADD_TO_AUDIT: "Denetim Ekle",
  ADDITIONAL: "Ilave",
  ADDITIONAL_COMMENTS: "Ilave Yorumlar",
  ADDITIONAL_REPAIR: "Ilave Onar\u0131m",
  ADDITIVE: "Ilave olunacak",
  ADDRESS: "Adres",
  ADDRESS_LINE1: "Adres Sat\u0131r\u0131 1",
  ADDRESS_LINE1_REQUIRED: "Adres Sat\u0131r\u0131 1 Gerekli",
  ADDRESS_LINE2: "Adres Sat\u0131r\u0131 2",
  ADJ_CLM: "Talebi Ayarla",
  ADJUST_CLAIM: "Talebi Ayarla",
  ADJUSTED_HOURS: "Ayarlanan Saatler",
  ADJUSTED_QUANTITY: "D\xFCzeltilmi\u015F Miktar",
  ADJUSTMENT_TYPE: "Ayarlama T\xFCr\xFC",
  ADVANCED_CLAIM_SUMMARY: "Geli\u015Fmi\u015F Kleymler \xD6zeti",
  AFTER_DELIVERY_INSPECTION: "TESL\u0130MAT SONRASI \u0130NCELEME",
  AGENCY_NAME: "Arac\u0131 Ad\u0131",
  ALL: "T\xFCm\xFC",
  ALL_ACCOUNTS: "T\xFCm Hesaplar",
  ALL_CLAIMS: "T\xFCm \u0130ddialar",
  ALL_CLAIMS_ARE_SUBJECT_TO_REVIEW: "T\xFCm talepler incelenebilir (daha fazla bilgi i\xE7in bkz. JD WAM 110.08)",
  ALL_CLAIMS_TAB: "T\xFCm \u0130ddialar ({count, number})",
  ALL_PART_REQUESTS: "T\xFCm Par\xE7a \u0130stekleri",
  ALL_PART_REQUESTS_WITH_COUNT: "T\xFCm Par\xE7a \u0130stekleri ({count})",
  ALL_PARTS_RETURNED: "\u0130ade Edilmi\u015F T\xFCm Par\xE7alar",
  AMOUNT: "Tutar",
  AMOUNT_1: "Tutar 1",
  AMOUNT_2: "Tutar 2",
  AMOUNT_3: "Tutar 3",
  AMOUNT_OF_USE: "Kullan\u0131m Miktar\u0131",
  AMOUNT_OF_USE_HISTORY_WITH_COUNT: "Kullan\u0131m Miktar\u0131 Ge\xE7mi\u015Fi ({count})",
  AMOUNT_OF_USE_IS_REQUIRED: "Kullan\u0131m Miktar\u0131 gereklidir",
  AMOUNT_OF_USE_REQUIRED: "Gereken kullan\u0131m miktar\u0131",
  AMOUNT_OF_USE_UNITS_REQUIRED: "Gereken kullan\u0131m birimleri miktar\u0131",
  AMOUNT_RECORDED: "Kaydedilen Miktar",
  AMOUNT_TO_BE_DEBITED: "Bor\xE7land\u0131r\u0131lacak Tutar",
  APLYPIP: "PIP Uygula",
  APPLICATION: "M\xFCracaat",
  APPLICATION_IS_REQUIRED: "M\xFCracaat gereklidi",
  APPLY: "Uygulamak",
  APPLY_TRAVEL: "Yol\xE7uluk Uygula",
  APPROVAL_DEALER_COMMENTS: "Onay Veren Bayi Yorumlar\u0131",
  APPROVAL_DETAILS: "Onay Detaylar\u0131",
  APPROVAL_LEVELS: "Onay D\xFCzeyleri",
  APPROVAL_REMARKS: "Onay A\xE7\u0131klamalar\u0131",
  APPROVAL_STATUS: "Onay Durumu",
  APPROVE: "Onayla",
  APPROVE_LABOR_RATE: "\u0130\u015F\xE7ilik \xDCcretini Onayla",
  APPROVE_MACHINE_STATUS_UPDATE: "Makine Durumu G\xFCncellemesini Onayla",
  APPROVE_PIP_CODE_REQUEST: "PIP Kodu \u0130steyini Onayla",
  APPROVE_SPECIAL_ALLOWANCE_CLAIM: "\xD6zel \xD6denek Talebini Onayla",
  APPROVED: "ONAYLANDI",
  APPROVED_CORE_VALUE: "Onaylanan Temel De\u011Fer",
  APPROVED_DATE_CANNOT_BE_BEFORE_SETUP_DATE: "Onayl\u0131 tarih, kurulum tarihinden \xF6nce olamaz",
  APPROVED_DIAGNOSTIC_AMOUNT: "Onaylanan Te\u015Fhis Miktar\u0131",
  APPROVED_DIAGNOSTIC_HOURS: "Onaylanm\u0131\u015F Te\u015Fhis Saatleri",
  APPROVED_IS_REQUIRED: "Onayl\u0131 gereklidir",
  APPROVED_LABOR_ADDITIVE: "Onaylanan \u0130\u015F\xE7ilik \u0130lavesi",
  APPROVED_LABOR_AMOUNT: "Onaylanan \u0130\u015F\xE7ilik Tutar\u0131",
  APPROVED_LABOR_HOURS: "Onaylanan \u0130\u015F\xE7ilik Saati",
  APPROVED_LABOR_TOTAL: "Onaylanan \u0130\u015F\xE7ilik Toplam\u0131",
  APPROVED_ON_SHELF_COST: "Onaylanan Raf Maliyeti",
  APPROVED_OTHER_CREDITS: "Onaylanan Di\u011Fer Alacaklar",
  APPROVED_PARTS: "Onaylanan Par\xE7alar",
  APPROVED_PARTS_ADDITIVE: "Onaylanan Par\xE7a \u0130lavesi",
  APPROVED_PARTS_TOTAL: "Onaylanan Par\xE7a Toplam\u0131",
  APPROVED_REJECTED: "Onayland\u0131/Reddedildi",
  APPROVED_REPAIR_AMOUNT: "Onayl\u0131 Onar\u0131m Tutar\u0131",
  APPROVED_REPAIR_HOURS: "Onayl\u0131 Tamir Saatleri",
  APPROVED_TAXES_TOTAL: "Onaylanan Vergi Toplam\u0131",
  APPROVED_TRAVEL_TOTAL: "Onaylanan Seyahat Toplam\u0131",
  APPROVER: "Onaylayan",
  ASCENDING: "y\xFCkselen (artan)",
  ATTACHMENTS: "Ekler",
  AUDIT_NUMBER: "Denetim Numaras\u0131",
  AUDIT_PLANNED: "Planlanan Denetim",
  AUDIT_REQUIREMENT: "Denetim Gereklili\u011Fi",
  AUDIT_RESULTS: "Denetim Sonu\xE7lar\u0131",
  AUDIT_STATUS: "Denetim Durumu",
  AUDIT_SUBMITTED_SUCCESSFULLY: "Denetim Ba\u015Far\u0131yla G\xF6nderildi",
  AUDIT_SUMMARY: "Denetim \xD6zeti",
  AUDIT_TYPE: "Denetim t\xFCr\xFC",
  AUDITS: "Denetimler",
  AUDITS_DUE_WITH_COUNT: "{countToDisplay} denetimin s\xFCre sonu",
  AUDITS_DUE_WITHIN_30_DAYS: "{countToDisplay} {count, plural, one {audit} other {audits}} 30 g\xFCn i\xE7inde sona eriyor",
  AUDITS_PAST_DUE_WITH_COUNT: "{countToDisplay} {count, plural, one {audit} other {audits}} s\xFCre sonu ge\xE7mi\u015F",
  AUTHORIZATION_NUMBER: "Yetki Numaras\u0131",
  AUTO_SUBMIT_FROM_DEALER_BUSINESS_SYSTEM: "Bayi \u0130\u015F Sisteminden Otomatik G\xF6nder",
  AVAILABLE: "MEVCUT",
  AVAILABLE_COLUMNS: "S\xFCtunlar\u0131 Mevcut",
  AVERAGE_DIAGNOSTICS_HOURS: "Ortalama Diyagnostik S\xFCresi (Saat cinsinden)",
  AVERAGE_LUG_HEIGHT: "Ortalama Bijon Y\xFCksekli\u011Fi",
  AVERAGE_LUG_HEIGHT_IS_REQUIRED: "Ortalama Lug Y\xFCksekli\u011Fi gereklidir",
  AVERAGE_REPAIR_HOURS: "Ortalama Tamir S\xFCresi (Saat cinsinden)",
  AVERAGE_REPLACEMENT_HOURS: "Ortalama De\u011Fi\u015Fiklik S\xFCresi (Saat cinsinden)",
  AVERAGE_TECH_PAY_RATE: "Ortalama Teknisyen Maa\u015F Oran\u0131",
  BACK: "Geri",
  BACK_TO_AUDIT: "Denetime Geri D\xF6n",
  BASE_MACHINE: "Base Machine",
  BASE_MACHINE_IMPLEMENTS: "Temel Makine Ekipmanlar\u0131",
  BASE_MACHINE_PIN: "Temel Makine PIN",
  BASIC_WARRANTY_ENDS: "Temel Garanti Biti\u015Fi",
  BASIC_WARRANTY_ESTIMATOR: "Temel Garanti Tahmin Edici",
  BASIC_WARRANTY_STARTS: "Temel Garanti Ba\u015Flang\u0131c\u0131",
  BASIS_FOR_SETTLEMENT: "Yerle\u015Fim icin Temel",
  BASIS_FOR_SETTLEMENT_AUDIT_COMMENTS: "Yerle\u015Fim icin Temel / Denetim Yorumlar\u0131",
  BASIS_FOR_SETTLEMENT_IS_REQUIRED: "Yerle\u015Fim icin Temel gereklidir",
  BATTERY: "AK\xDC",
  BEGIN_DATE: "Ba\u015Flang\u0131\xE7 Tarihi",
  BRANCH: "\u015Eube",
  BUILT: "Derleme",
  BUSINESS_END: "\u0130\u015F Sonu",
  CAN_THE_MACHINE_BE_PUT_BACK_INTO_SERVICE: "Makine tekrar hizmete sokulabilir mi?",
  CANCEL: "\u0130ptal",
  CERTIFIED_LETTER_SENT: "Onayl\u0131 Mektup G\xF6nderildi",
  CGST: "CGST",
  CHANGE_RESPONSIBLE_DEALER: "Sorumlu Bayiyi De\u011Fi\u015Ftir",
  CHANGE_STATUS: "Durumu De\u011Fi\u015Ftir",
  CHANGE_STATUS_FOR: "{pin} i\xE7in De\u011Fi\u015Fiklik Durumu",
  CHANGED: "De\u011Fi\u015Ftirildi",
  CHANGED_BY: "De\u011Fi\u015Ftiren",
  CHANGED_ON: "De\u011Fi\u015Fiklik Tar.",
  CHINESE: "\xC7ince",
  CITY: "\u015Eehir",
  CITY_REQUIRED: "\u015Eehir Gerekli",
  CLAIM: "Kleym",
  CLAIM_COUNT_WITH_PARENTHESIS: "({countToDisplay} {count, plural, one {Claim} other {Claims}})",
  CLAIM_DEBIT: "\u0130ddia Borcu",
  CLAIM_DETAILS: "\u0130ddia Detaylar\u0131",
  CLAIM_DRAFT: "TASLAK",
  CLAIM_HISTORY: "24 aylik iddia tarixi",
  CLAIM_HISTORY_WITH_COUNT: "24 aylik iddia tarixi ({count})",
  CLAIM_NUMBER: "\u0130ddia Numaras\u0131",
  CLAIM_RECOVER_PERCENTAGE: "(%{percentage})",
  CLAIM_SEARCH: "\u0130ddia Aramas\u0131",
  CLAIM_STATUS: "\u0130ddia Durumu",
  CLAIM_TYPE: "\u0130ddia T\xFCr\xFC",
  CLAIM_TYPES: "Kleym T\xFCrleri",
  CLAIM_UPDATED_SUCCESSFULLY: "Kleym Ba\u015Far\u0131yla G\xFCncellendi",
  CLAIM_VALUE: "\u0130ddia De\u011Feri",
  CLAIM_VALUE_DETAILS: "Kleym De\u011Feri Detaylar\u0131",
  CLAIM_WITH_NUMBER: "Kleym {claimNumber}",
  CLAIMS: "\u0130ddialar",
  CLAIMS_IN_PROGRESS: "\u0130ddialar Devam Ediyor",
  CLAIMS_IN_PROGRESS_WITH_COUNT: "\u0130ddialar Devam Ediyor ({count})",
  CLAIMS_OVERVIEW: "\u0130ddialara Genel Bak\u0131\u015F",
  CLAIMS_OVERVIEW_TAB: "\u0130ddialara Genel Bak\u0131\u015F ({count})",
  CLAIMS_WITH_COUNT: "\u0130ddia {count}",
  CLICK_FOR_DETAILS: "(Detaylar i\xE7in t\u0131klay\u0131n)",
  CLICK_TO_VIEW_ALL: "T\xFCm\xFCn\xFC G\xF6r\xFCnt\xFClemek \u0130\xE7in T\u0131kla",
  CLOSE: "Kapat",
  CLOSED_PART_REQUESTS: "Kapal\u0131 Par\xE7a Talepleri",
  CLOSING: "Kapan\u0131\u015F",
  CLOSING_ACCOUNT: "Kapan\u0131\u015F Hesab\u0131",
  CLOSING_ACCOUNT_WITH_COUNT: "Kapan\u0131\u015F hesab\u0131 ({count})",
  CODE: "Kod",
  COLLAPSE_ALL: "T\xFCm\xFCn\xFC Daralt",
  COMMENT: "Yorum",
  COMMENTS: "Yorumlar",
  COMMENTS_IS_REQUIRED: "Yorumlar gereklidir",
  COMMENTS_TO_DEALER: "Bayi Yorumlar\u0131",
  COMMON_LABOR_TYPES_WARNING: "Se\xE7ilen hesaplar i\xE7in t\xFCm \u0130\u015F\xE7ilik t\xFCrleri kullan\u0131lamaz",
  COMPANY: "\u015Eirket",
  COMPANY_CONTRIBUTION: "\u015Eirket Katk\u0131s\u0131",
  COMPANY_CONTRIBUTION_IS_REQUIRED: "\u015Eirket Katk\u0131s\u0131 Gereklidir",
  COMPLAINT_CAUSE: "\u015Eikayetin nedeni neydi?",
  COMPLAINT_CAUSE_IS_REQUIRED: "\u015Eikayet nedeni gereklidir",
  COMPLAINT_CORRECTION: "\u015Eikayet nas\u0131l d\xFCzeltildi?",
  COMPLAINT_CORRECTION_IS_REQUIRED: "\u015Eikayet d\xFCzeltme gereklidir",
  COMPLETE: "Tamamland\u0131",
  COMPLETED: "Tamamland\u0131",
  COMPLETED_BY: "Tamamlayan",
  COMPLETED_DATE: "Tamamlama Tarihi",
  COMPLETED_IN_LAST_24_MONTHS: "Son 24 Ayda Tamamlanan",
  COMPLETION_STATUS: "Tamamlama Durumu",
  COMPONENT: "Bile\u015Fen",
  COMPONENT_CODE: "Bile\u015Fen Kod",
  COMPONENT_CREATED_SUCCESSFULLY: "Bile\u015Fen Ba\u015Far\u0131yla Yarat\u0131ld\u0131",
  COMPONENT_DELETED_SUCCESSFULLY: "Bile\u015Fen Ba\u015Far\u0131yla Silindi",
  COMPONENT_SERIAL_NUMBER: "Bile\u015Fen Seri Numaras\u0131",
  COMPONENT_SUCCESSFULLY_UPDATED: "Bile\u015Fen Ba\u015Far\u0131yla G\xFCncellendi",
  COMPONENTS: "Bile\u015Fenler",
  CONFIRM: "Tasdik etmek",
  CONFIRM_ADDITIONAL_REPAIR: "\u0130lave tamir eklemek istedi\u011Finiden emin misiniz?",
  CONFIRM_ADJUST_CLAIM: "Bu Talebi ayarlamak istedi\u011Finiden emin misiniz?",
  CONFIRM_CLOSING_ACCOUNT: "Bu transferi kabul etmek istedi\u011Finizden emin misiniz?",
  CONFIRM_COPY_CLAIM: "Bu Talebi kopyalamak istedi\u011Finizden emin misiniz?",
  CONFIRM_DELETE_ATTACHMENT: "Ekli dosyay\u0131 silmek istedi\u011Finizden emin misiniz?",
  CONFIRM_DELETE_CLAIM: "Bu Talebi silmek istedi\u011Finizden emin misiniz?",
  CONFIRM_DELETE_REGISTRATION: "Bu Kayd\u0131 silmek istedi\u011Finizden emin misiniz?",
  CONFIRM_EDIT_CLAIM: "Bu iddiay\u0131 ger\xE7ekten de\u011Fi\u015Ftirmek istiyor musunuz?",
  CONFIRM_RECONCILE_CLAIM: "Bu Talebi kar\u015F\u0131la\u015Ft\u0131rmak istedi\u011Finizden emin misiniz?",
  CONFIRM_RESEND_XML: "XML'yi yeniden g\xF6ndermek istedi\u011Finizden emin misiniz? L\xFCtfen 24-48 saat i\xE7inde g\xF6r\xFCn\xFCr olmas\u0131na izin verin.",
  CONFIRM_SKIP_AUDIT: "Bu Talebi atlamak istedi\u011Finize emin misiniz?",
  CONFIRM_UNDO_REGISTRATION: "Bu Kayd\u0131 geri almak istedi\u011Finizden emin misiniz?",
  CONTACTED: "\u0130leti\u015Fim Kuruldu",
  CONTAINS: "\u0130\xE7erik",
  CONTRACT_NUMBER: "S\xF6zle\u015Fme Numaras\u0131",
  CONTRACT_PURCHASED: "Sat\u0131n Al\u0131nan S\xF6zle\u015Fme",
  CONTRACT_TYPE: "S\xF6zle\u015Fme T\xFCr\xFC",
  COPY_CLAIM: "Talebi Kopyala",
  CORE: "Esas",
  CORE_VALUE: "Esas De\u011Fer",
  COUNTRY: "\xDClke",
  COUNTRY_REQUIRED: "\xDClke Gerekli",
  COURIER_ACCOUNT_NUMBER: "Kurye Hesap Numaras\u0131",
  COURIER_NAME: "Kurye Ad\u0131",
  COVERAGE_DECISION: "Kapsam Karar\u0131",
  COVERAGE_TYPE: "Kapsam T\xFCr\xFC",
  CRDMEM: "Alacak Dekontu",
  CREATE: "Olu\u015Ftur",
  CREATE_CLAIM: "\u0130ddia Yarat",
  CREATE_LAYOUT: "Mizanpaj Olu\u015Ftur",
  CREATE_NON_TRACKED_PIN_HELP_TEXT: "Bu \xFCr\xFCne ili\u015Fkin bir taleb dosyalamadan \xF6nce buna ili\u015Fkin baz\u0131 bilgileri bizimle payla\u015Fman\u0131z gerekir",
  CREATE_PIP_CLAIM: "PIP Talebi Olu\u015Ftur",
  CREATE_PIP_CLAIMS: "PIP Talepleri Olu\u015Ftur",
  CREATE_PRODUCT_RECORD: "\xDCr\xFCn Kayd\u0131 Olu\u015Ftur",
  CREATE_REQUEST: "Talep Olu\u015Ftur",
  CREATE_TRANSFER_PENDING: "Aktar\u0131m Bekliyor",
  CREATE_TRANSFER_SERVICE_UNAVAILABLE: "Transfer Hizmetleri Olu\u015Fumu Kullan\u0131lamiyor",
  CREATED: "Olu\u015Fturuldu",
  CREATED_BY: "Olu\u015Fturan",
  CREATED_DATE: "Olu\u015Fturulma Tarihi",
  CREATED_ON: "Olu\u015Fturma",
  CREATION_DATE: "Olu\u015Fturma Tarihi",
  CREDIT_MEMO: "Alacak Dekontu",
  CREDIT_MEMO_DATE: "Alacak Dekontu Tarihi",
  CREDIT_MEMO_ISSUE_DATE: "Alacak Dekontu Verildi",
  CREDIT_MEMO_NUMBER: "Alacak Dekontu Numaras\u0131",
  CREDIT_MEMO_PROCESS_DATE: "Alacak Dekontu \u0130\u015Flendi",
  CREDIT_MEMO_SELECTED: "Alacak Dekontu Se\xE7ildi",
  CREDIT_MEMOS: "Alacak Dekontlar\u0131",
  CRITERIA: "Kriterler",
  CRT: "Olu\u015Ftur",
  CSV_SEPARATOR: "CSV Ay\u0131r\u0131c\u0131",
  CURRENCY: "Para Birimi",
  CURRENT: "Mevcut",
  CURRENT_ACCOUNT: "Mevcut Hesap",
  CURRENT_AMOUNT_OF_USE: "Mevcut Kullan\u0131m Miktar\u0131",
  CURRENT_CUSTOMER: "Ge\xE7erli M\xFC\u015Fteri",
  CURRENT_DEALER: "Mevcut Bayi",
  CURRENT_DEALER_DISTANCE: "Ge\xE7erli Sat\u0131c\u0131 Uzakl\u0131\u011F\u0131",
  CURRENT_DEALER_LAST_SERVICE_DATE: "Ge\xE7erli Sat\u0131c\u0131 Son Servis Tarihi",
  CURRENT_DEALER_LOCATION: "Ge\xE7erli Bayi Konumu",
  CURRENT_HOURS: "Ge\xE7erli Saatler",
  CURRENT_QUANTITY: "Ge\xE7erli Miktar",
  CURRENT_RESPONSIBLE_DEALER: "Ge\xE7erli Sorumlu Sat\u0131c\u0131",
  CURRENT_VALUES: "Ge\xE7erli De\u011Ferler",
  CURRENTLY_ON_RENT: "Halen Kirada",
  CUSTOM_RANGE: "\xD6zel Aral\u0131k",
  CUSTOM_VALUES: "\xD6zel De\u011Ferler",
  CUSTOMER: "M\xFC\u015Fteri",
  CUSTOMER_CONTRIBUTION: "M\xFC\u015Fteri Katk\u0131s\u0131",
  CUSTOMER_CONTRIBUTION_IS_REQUIRED: "M\xFC\u015Fteri Katk\u0131s\u0131 Gereklidir",
  CUSTOMER_CREATED_SUCCESSFULLY: "M\xFC\u015Fteri ba\u015Far\u0131yla olu\u015Fturuldu",
  CUSTOMER_DETAILS: "M\xFC\u015Fteri Detaylar\u0131",
  CUSTOMER_DETAILS_UPDATED_SUCCESSFULLY: "M\xFC\u015Fteri detaylar\u0131 ba\u015Far\u0131yla g\xFCncellendi",
  CUSTOMER_INFORMATION: "M\xFC\u015Fteri Bilgileri",
  CUSTOMER_INFORMATION_IS_REQUIRED: "M\xFC\u015Fteri bilgisi gerekiyor.",
  CUSTOMER_INVALID: "M\xFC\u015Fteri ge\xE7ersiz",
  CUSTOMER_NAME: "M\xFC\u015Fteri Ad\u0131",
  CUSTOMER_NAME_IS_REQUIRED: "M\xFC\u015Fteri bilgisi gerekiyor.",
  CUSTOMER_NOT_FOUND: "M\xFC\u015Fteri Bulunamad\u0131",
  CUSTOMER_REQUIRED: "Gereken m\xFC\u015Fteri",
  CUSTOMER_RESOLUTION: "M\xFC\u015Fteri \xC7\xF6z\xFCm\xFC",
  CUSTOMER_RESOLUTION_IS_REQUIRED: "M\xFC\u015Fteri \xC7\xF6z\xFCm\xFC Gereklidir",
  CUSTOMER_SEARCH: "M\xFC\u015Fteri Aramas\u0131",
  CUSTOMER_UPDATED_SUCCESSFULLY: "M\xFC\u015Fteri ba\u015Far\u0131yla g\xFCncellendi",
  DAMAGED_MACHINES_HELP_TEXT: "Hasarl\u0131 makineler i\xE7in garanti otomatik olarak ask\u0131ya al\u0131n\u0131r, ta ki bu form g\xF6zden ge\xE7irilene ve garanti yeniden verilmek \xFCzere TCSM taraf\u0131ndan onaylanana kadar. Hasarl\u0131 makineler sadece Zorunlu ve G\xFCvenlik PIP'leri i\xE7in yeterlidir.",
  DATE: "Tarih",
  DATE_FORMAT: "Tarih Bi\xE7imi",
  DATE_ISSUED: "Yay\u0131mlama Tarihi",
  DATE_OF_CERTIFIED_LETTER: "Onayl\u0131 Mektub Tarihi",
  DATE_OF_EVENT_CAUSING_DAMAGE: "Hasara neden olan olay tarihi",
  DATE_OF_LAST_PERSONAL_CONTACT: "Son \xD6zel \u0130rtibat Tarihi",
  DATE_RECALLED_PART_WAS_SHIPPED_SENT: "Geri \xC7a\u011Fr\u0131lan Par\xE7an\u0131n Sevk Edildi\u011Fi/G\xF6nderildi\u011Fi Tarih",
  DATE_REFUSED: "Reddedilme Tarihi",
  DATE_SUBMITTED: "G\xF6nderme Tarihi",
  DAYS_FROM_REGISTRATION: "Kay\u0131ttan sonraki g\xFCn say\u0131s\u0131",
  DAYS_LEFT: "Kalan G\xFCn",
  DAYS_LEFT_WITH_COUNT: "{daysToDisplay} G\xFCn kald\u0131",
  DAYS_ON_RENT: "Kiradaki G\xFCn Say\u0131s\u0131",
  DAYS_REMAINING: "Kalan G\xFCn Say\u0131s\u0131",
  DAYS_REMAINING_WITH_COUNT: "{daysToDisplay} {days, plural, one {Day} other {Days}} Kald\u0131",
  DAYS_TO_DISPLAY: "G\xF6r\xFCnt\xFClenecek G\xFCn Say\u0131s\u0131",
  DBS: "DBS",
  DEALER: "Bayi",
  DEALER_ACCOUNT: "Bayi Hesab\u0131",
  DEALER_ACCOUNT_IS_REQUIRED: "Bayi Hesab\u0131 gereklidir",
  DEALER_ACCOUNTS: "Bayi Hesaplar\u0131",
  DEALER_CITY: "Bayi \u015Eehri",
  DEALER_COMMENTS: "Bayi Yorumlar\u0131",
  DEALER_CONTRIBUTION: "Bayi Katk\u0131s\u0131",
  DEALER_CONTRIBUTION_IS_REQUIRED: "Bayi Katk\u0131s\u0131 Gereklidir",
  DEALER_HIERARCHY_ACCOUNT: "{account} ({industryIndicator})",
  DEALER_INVOICE_NUMBER: "Bayi Fatura Numaras\u0131",
  DEALER_INVOICE_UPDATED: "BAY\u0130 FATURASI G\xDCNCELLEND\u0130",
  DEALER_INVOICE_UPDATES: "Bayi Faturas\u0131",
  DEALER_INVOICES: "Bayi Faturalar\u0131",
  DEALER_LOCATION: "Bayi Konumu",
  DEALER_LOCATION_FILTER: "Konumlar\u0131 Filtrele",
  DEALER_LOCATION_IS_REQUIRED: "Bayi Konumu gereklidir",
  DEALER_LOCATIONS: "Bayi Konumlar\u0131",
  DEALER_NAME: "Bayi Ad\u0131",
  DEALER_PHONE: "Bayi Telefon No",
  DEALER_POSTAL_CODE: "Posta Kodu",
  DEALER_RECOMMENDATIONS: "Sat\u0131c\u0131 \xD6nerileri",
  DEALER_RECOMMENDATIONS_TAB: "Sat\u0131c\u0131 \xD6nerileri ({count})",
  DEALER_REVIEW_REQUEST_SUCCESSFULLY: "Sat\u0131c\u0131 Ba\u015Far\u0131yla G\xF6zden Ge\xE7irildi",
  DEALER_SEARCH: "Bayi Arama",
  DEALER_SEARCH_CHOOSE_CITY_NAME_ACCOUNT: "Bayileri aramak i\xE7in Ad\u0131, \u015Eehri veya Hesab\u0131 girin",
  DEALER_STATE: "Bayi, Vilayet/\u0130l\xE7e",
  DEALER_SUBMISSION_WITH_CURRENCY: "Bayi G\xF6nderimi ({currency})",
  DEALER_TRANSFER_HISTORY: "Bayi Transfer Ge\xE7mi\u015Fi",
  DEALER_TRANSFER_REQUEST_SUCCESSFULLY: "Sat\u0131c\u0131 Transfer Talebi Ba\u015Far\u0131yla S\u0131raya Al\u0131nd\u0131",
  DEALER_WARRANTY: "Bayi Garantisi",
  DEALERS: "Bayiler",
  DEALERSHIP: "Bayilik",
  DEBIT: "Bor\xE7",
  DEBIT_AMOUNT: "Bor\xE7 Miktar\u0131",
  DEBIT_FOR_CLAIM_NUMBER: "{claimNumber} Borcu",
  DEBIT_REQUIRED: "Kleym Edilen Bor\xE7",
  DEBIT_REQUIRED_STATUS: "Kleym Edilen Bor\xE7 Durumu",
  DEBIT_SUBMITTED_SUCCESSFULLY: "Bor\xE7 Ba\u015Far\u0131yla G\xF6nderildi",
  DEBIT_TYPE: "Bor\xE7 t\xFCr\xFC",
  DEBITED: "Bor\xE7land\u0131r\u0131lacak",
  DEBITS_TO_THIS_CLAIM_MUST_BE_COMPLETED_THROUGH_MANUAL_DEBIT_PROCESS: "Bu iddiaya ait bor\xE7lar\u0131n, manuel bor\xE7 s\xFCreci arac\u0131l\u0131\u011F\u0131yla tamamlanmas\u0131 gerekir",
  DECIMAL_FORMAT: "Ondal\u0131k Format",
  DECISION_UPDATED: "Karar G\xFCncellendi",
  DECLINE: "Reddet",
  DEDUCTIBLE: "\u0130ndirim",
  DEERE_REMARKS: "Deere A\xE7\u0131klamalar\u0131",
  DEFAULT_WARRANTY: "Varsay\u0131lan Garanti",
  DEL: "Sil",
  DELETE: "Sil",
  DELETE_ATTACHMENT: "Eki Sil",
  DELETE_CLAIM: "Talebi Sil",
  DELETE_REGISTRATION: "Kayd\u0131 Sil",
  DELETE_REGISTRATION_SUCCESS: "Kay\u0131t Silme Ba\u015Far\u0131l\u0131",
  DELETED: "S\u0130L\u0130ND\u0130",
  DELETED_BY: "Taraf\u0131ndan Silindi",
  DELIVERED: "Teslim Edildi",
  DELIVERED_IS_REQUIRED: "Teslim Edildi gereklidir",
  DELIVERY_DATE: "Teslim Tarihi",
  DELIVERY_DATE_REQUIRED: "Teslim Tarihi gerekli",
  DELIVERY_DATES: "Teslimat Tarihleri",
  DELIVERY_NO_DOCUMENTS: "Teslimat Numaras\u0131 Belgeleri",
  DEMO_RENTAL_BEGIN_DATE: "Demo/Kiralama Ba\u015Flang\u0131\xE7 Tarihi",
  DEMO_RENTAL_CHOOSE_DEALERS_STATUS: "Bayileri ve Durumu Se\xE7",
  DEMO_RENTAL_END_DATE: "Demo/Kiralama Biti\u015F Tarihi",
  DEMO_RENTAL_HISTORY: "Demo Kiralama Ge\xE7mi\u015Fi",
  DENY: "Reddet",
  DENY_MACHINE_STATUS_UPDATE: "Makine Durumu G\xFCncellemesini Reddet",
  DENY_PIP_CODE_REQUEST: "PIP Kodu Talebini Reddet",
  DESCENDING: "eksilen (azalan)",
  DESCRIPTION: "a\xE7\u0131klama",
  DESCRIPTION_OF_DAMAGE: "Hasar\u0131n a\xE7\u0131klamas\u0131",
  DESCRIPTION_OF_EVENT_CAUSING_DAMAGE: "Hasara neden olan olay\u0131n a\xE7\u0131klamas\u0131",
  DESELECT_ALL: "T\xFCm Se\xE7imleri Kald\u0131r",
  DETAILS: "Detaylar",
  DIAGNOSTICS_COVERED: "Kapsam Dahilindeki Diyagnostikler",
  DIS_VSR: "Mesajlar\u0131 G\xF6r\xFCnt\xFCle",
  DISPLAY: "G\xF6r\xFCnt\xFCle",
  DISPLAY_CLAIM: "Kleymi G\xF6r\xFCnt\xFCle",
  DISPLAY_CREDIT_MEMO: "Alacak Dekontunu G\xF6r\xFCnt\xFCle",
  DISPLAY_FORMAT: "Ekran Format\u0131",
  DISPLAY_PRODUCT: "\xDCr\xFCn G\xF6r\xFCnt\xFCle",
  DISPLAY_TAG: "Etiketi G\xF6r\xFCnt\xFCle",
  DISTANCE: "Mesafe",
  DISTANCE_FROM_CURRENT_DEALER: "Ge\xE7erli Sat\u0131c\u0131dan Uzakl\u0131k",
  DISTANCE_FROM_POTENTIAL_DEALER: "Potansiyel Sat\u0131c\u0131dan Uzakl\u0131k",
  DIVISION: "B\xF6l\xFCm",
  DIVISION_SUMMARY: "B\xF6l\xFCm \xD6zeti",
  DO_YOU_WANT_TO_SAVE_YOUR_CHANGES: "De\u011Fi\u015Fikliklerinizi kaydetmek istiyor musunuz?",
  DOES_NOT_CONTAIN: "I\xE7ermiyor",
  DOWNLOAD_TO_EXCEL: "Excel'e \u0130ndir",
  DOWNTIME: "\xC7al\u0131\u015Fmama S\xFCresi",
  DOWNTIME_IS_REQUIRED: "\xC7al\u0131\u015Fmama S\xFCresi gereklidir",
  DRAFT: "Taslak Olarak Kaydet",
  DTAC_CASE: "DTAC Vakas\u0131",
  DTAC_CASE_NUMBER: "DTAC Vaka Numaras\u0131",
  DTAC_SOLUTION: "DTAC \xC7\xF6z\xFCm\xFC",
  DUE_DATE: "Vade Tarihi",
  DUE_WITHIN_3_MONTHS: "3 Ay \u0130\xE7inde Sona Eriyor",
  DUPLICATE_PIN_PLATE: "Yinelenen PIN Plakas\u0131",
  DUPLICATE_PIN_PLATE_REQUEST_UPDATED: "Yinelenen PIN Plakas\u0131 \u0130ste\u011Fi G\xFCncellendi",
  DUPLICATE_PIN_PLATE_SUCCESSFULLY_CREATED: "Yinelenen PIN Plakas\u0131 \u0130ste\u011Fi Ba\u015Far\u0131yla Olu\u015Fturuldu",
  DUPLICATE_PIN_PLATE_WITH_COUNT: "Yinelenen PIN Plakas\u0131 \u0130ste\u011Fi ({count})",
  EDIT: "D\xFCzenle",
  EDIT_CUSTOMER: "M\xFC\u015Fteriyi D\xFCzenle",
  EDIT_LAYOUT: " Mizanpaj D\xFCzenle",
  EDIT_WITH_PARENTHESES: "(D\xFCzenle)",
  EFFECTIVE: "Ge\xE7erli",
  EFFECTIVE_DATE: "Ge\xE7erlilik Tarihi",
  EMAIL: "E-posta",
  EMISSIONS_PART_SEARCH: "Emisyon Par\xE7a Aramas\u0131",
  END_DATE: "Biti\u015F Tarihi",
  END_USE: "Kullan\u0131m Sonu",
  END_USE_CODE: "Son Kullan\u0131c\u0131 Kodu",
  END_USE_CODE_REQUIRED: "Gereken Kullan\u0131m Sonu Kodu",
  ENDS_WITH: "Bununla biter",
  ENGLISH: "ingilizce",
  ENTER_A_NUMBER_BETWEEN_0_AND_1000: "0 ve 1000 aras\u0131nda bir say\u0131 girin",
  ENTER_A_NUMBER_BETWEEN_0_AND_10000: "0 ila 10000 aras\u0131nda bir say\u0131 girin",
  ENTER_A_NUMBER_FROM_1_TO_9999: "1 ila 9999 aras\u0131nda bir say\u0131 girin",
  ENTER_A_PART_NUMBER: "Par\xE7a Numaras\u0131n\u0131 Girin",
  ENTER_COMMENTS_BEFORE_ACCEPTING: "Kabul etmeden \xF6nce yorumlar\u0131 girin",
  EQUALS: "E\u015Fitlikler",
  ERROR: "HATA:",
  ERROR_MESSAGE_TITLE: "Bir hata olu\u015Ftu:",
  ERROR_MESSAGES: "Hata Mesajlar\u0131",
  ERROR_MESSAGES_TITLE: "Birden fazla hata olu\u015Ftu:",
  ERROR_NETWORK_ISSUES: "Bir \u015Febeke hatas\u0131, verilerin y\xFCklenmesini \xF6nledi, l\xFCtfen yeniden deneyin",
  ERROR_NO_DATA_TO_EXPORT: "D\u0131\u015Far\u0131 aktar\u0131lacak veri yok",
  ERROR_RETRIEVING_CUSTOMER_INFORMATION: "M\xFC\u015Fteri bilgileri al\u0131n\u0131rken hata olu\u015Ftu",
  ERROR_SAP: "Sunucuya ba\u011Flan\u0131lam\u0131yor.  Sorun devam ederse sorununuzu \xE7\xF6zmede yard\u0131m almak i\xE7in \"Bize Ula\u015F\u0131n\" ba\u011Flant\u0131s\u0131n\u0131 kullan\u0131n.",
  ERROR_SESSION: "Oturumunuzun s\xFCresi doldu.  Tekrar oturum a\xE7mak i\xE7in sayfay\u0131 yenileyin.",
  ERROR_UNHANDLED: "Sistem, beklenmedik bir hata ile kar\u015F\u0131la\u015Ft\u0131.  Sorun devam ederse sorununuzu \xE7\xF6zmede yard\u0131m almak i\xE7in l\xFCtfen \"Yard\u0131m\" \xF6zelli\u011Fini ya da \"Bize Ula\u015F\u0131n\" ba\u011Flant\u0131s\u0131n\u0131 kullan\u0131n.",
  ERROR_UPLOADING_FILE: "Dosya eklenmedi",
  ESTIMATED_BASIC_DATE: "Tahmini Temel Tarih",
  ESTIMATED_BASIC_DAYS: "Tahmini Temel G\xFCn Say\u0131s\u0131",
  ESTIMATES_MAY_NOT_REFLECT_DEMO_STATUS_OR_HOURS_NOT_YET_REPORTED: "Tahminler demo durumunu yans\u0131tmayabilir veya saat hen\xFCz raporlanmam\u0131\u015Ft\u0131r",
  EXCEEDS_DEMO_THRESHOLD: "Demo E\u015Fi\u011Fini A\u015F\u0131yor",
  EXCHANGE_RATE: "D\xF6viz kuru",
  EXCLUDED_PINS_ARE_NOT_INCLUDED_IN_THIS_REPORT: "Hari\xE7 tutulan PIN'ler bu rapora dahil edilmedi.",
  EXECUTE: "Y\xFCr\xFCt",
  EXPAND_ALL: "T\xFCm\xFCn\xFC Geni\u015Flet",
  EXPECTED_FIRST_USE: "Beklenen \u0130lk Kullan\u0131m",
  EXPIRATION_DATE: "Sona erme tarihi",
  EXPIRED: "Kullan\u0131m S\xFCresi Dolmu\u015F",
  EXPIRED_PART_REQUESTS: "S\xFCresi dolan par\xE7a talepleri",
  EXPIRED_PIPS: "S\xFCresi dolan PIP'ler",
  EXPIRES: "Son Kullanma Tarihi",
  EXPIRING_SOON: "S\xFCresi Yak\u0131nda Doluyor",
  EXPORT: "\u0130hracat",
  EXTENDED_WARRANTY: "Uzat\u0131lm\u0131\u015F Garanti",
  FACTORY: "FABR\u0130KA",
  FACTORY_NAME: "Fabrika Ad\u0131",
  FAILED: "Ba\u015Far\u0131s\u0131z",
  FAILED_AREA: "Ba\u015Far\u0131s\u0131z Alan",
  FAILED_AREA_IS_REQUIRED: "Ba\u015Far\u0131s\u0131z Alan\u0131 gereklidir",
  FAILED_DATE: "Ba\u015Far\u0131s\u0131z Tarihi",
  FAILED_DATE_IS_REQUIRED: "Ba\u015Far\u0131s\u0131z Tarihi gereklidir",
  FAILED_MODE: "Ba\u015Far\u0131s\u0131z Modu",
  FAILED_MODE_COMMENTS: "Ba\u015Far\u0131s\u0131z Modu Yorumlar\u0131",
  FAILED_PART: "Ar\u0131zal\u0131 Par\xE7a",
  FAILED_PART_DESCRIPTION: "Ar\u0131zal\u0131 Par\xE7a A\xE7\u0131klamas\u0131",
  FAILED_PART_IS_A_REMAN_PART: "Ar\u0131zal\u0131 Par\xE7a bir ReMan Par\xE7a",
  FAILED_PART_IS_REQUIRED: "Ar\u0131zal\u0131 Par\xE7a gereklidir",
  FAILED_PART_SERIAL: "Ar\u0131zal\u0131 Par\xE7a Seri Numaras\u0131",
  FAILED_PART_SERIAL_IS_REQUIRED: "Ar\u0131zal\u0131 Par\xE7a Seri Numaras\u0131 gereklidir",
  FAILURE_DATE: "Ar\u0131za Tarihi",
  FAILURE_INFORMATION: "Ar\u0131za Bilgisi",
  FAILURE_MODE: "Ar\u0131za Modu",
  FAILURE_MODE_IS_REQUIRED: "Ba\u015Far\u0131s\u0131z Mod gereklidir",
  FAILURE_PART: "Ar\u0131zal\u0131 Par\xE7a",
  FAILURE_PART_DESCRIPTION: "Ar\u0131zal\u0131 Par\xE7a A\xE7\u0131klamas\u0131",
  FAILURE_PART_IS_REQUIRED: "Ar\u0131zal\u0131 par\xE7a gerekli",
  FAILURE_TO_RETURN_PARTS_WARNING: "Talep edilen par\xE7alar\u0131n iade edilmemesi bir bor\xE7lanmaya neden olabilir.",
  FAVORITES: "S\u0131k kullan\u0131lanlar",
  FILE_NAME: "Dosya Ad\u0131",
  FILE_SIZE_IS_TOO_BIG: "Dosya Boyutu \xE7ok B\xFCy\xFCk (Maksimum Boyut: 100 MB)",
  FILE_SIZE_IS_TOO_BIG_CSV: "Dosya Boyutu \xE7ok B\xFCy\xFCk (Maksimum Boyut: 1 MB)",
  FILE_UPLOAD_MESSAGE: "Dosyalar\u0131 Buraya B\u0131rak veya Dosyalar\u0131 Ekle (Maksimum Boyut: 100 MB)",
  FILE_UPLOAD_MESSAGE_CSV: "Dosyalar\u0131 Buraya B\u0131rak veya Dosyalar\u0131 Ekle (Maksimum Boyut: 1 MB)",
  FILE_UPLOAD_MESSAGE_IMAGE: "Resim Buraya B\u0131rak veya Resim Ekle (Maksimum Boyut: 100 MB).",
  FILE_UPLOAD_MESSAGE_SINGLE: "Buraya Tek Bir Dosya B\u0131rak\u0131n veya Ekle'ye T\u0131klay\u0131n (Maksimum Boyut: 100 MB)",
  FILE_UPLOAD_UNABLE_TO_READ: "Sistem dosyan\u0131z\u0131 okuyamad\u0131.  L\xFCtfen \u015Fablonu \u015Fablonla kar\u015F\u0131la\u015Ft\u0131r\u0131n ve yeniden deneyin.",
  FILES: "Dosyalar",
  FILTER_PLACEHOLDER: "Filtre Sonu\xE7lar\u0131",
  FILTER_WITH_ELLIPSIS: "Filtre",
  FILTERED_BY_COLUMN_ID: "Filtreleyen: {columnId}",
  FIND_CUSTOMER: "M\xFC\u015Fteri Bul",
  FINNISH: "Fince",
  FIRST_MAINTENANCE: "\u0130LK BAKIM",
  FIRST_NAME: "Ad\u0131",
  FIRST_NAME_IS_REQUIRED: "Ad gereklidir",
  FIRST_SHIP_TO_LOCATION: "\u0130lk Sevk Yeri Konumu",
  FIRST_USE: "\u0130lk Kullan\u0131m",
  FISCAL_YEAR: "Mali Y\u0131l",
  FLUID_SAMPLING_REQUIRED: "Ak\u0131\u015Fkan \xD6rne\u011Fi Gerekiyor",
  FORWARDED: "\u0130LET\u0130LD\u0130",
  FRENCH: "Frans\u0131zca",
  FRWRD: "\u0130let",
  FULL_DEBIT: "Tam Bor\xE7",
  GENERAL: "Genel",
  GERMAN: "Almanca",
  GET_MAINTENANCE_PLANS: "Bak\u0131m Planlar\u0131n\u0131 Al",
  GOODS_INSTALLATION_VAT: "\xDCr\xFCn Kurulumu KDV'si",
  GRACE_PERIOD: "\xDCcretsiz Kullan\u0131m S\xFCresi",
  GREATER_THAN: "Daha b\xFCy\xFCk",
  GREATER_THAN_OR_EQUALS: "Daha b\xFCy\xFCk veya e\u015Fitlik",
  GROUP_COMPLETE: "Grup Tamamland\u0131",
  GST_PERCENTAGE: "GST Y\xFCzde",
  HISTORY_TO_DISPLAY: "G\xF6r\xFCnt\xFClenecek ge\xE7mi\u015F (g\xFCn)",
  HOME: "Ev",
  HOUR_LIMIT: "Saat S\u0131n\u0131r\u0131",
  HOURS: "Saat",
  HOURS_ON_RENT: "Kiral\u0131k Saatleri",
  HSN_SAC_CODE: "HSN/SAC Kod",
  IGST: "IGST",
  IMPLEMENTS: "Ekipmanlar",
  IN_RANGE: "Aral\u0131k i\xE7erisinde",
  INCENTIVE: "\xF6zendirici",
  INCENTIVE_PROGRAMS: "Te\u015Fvik Programlar\u0131",
  INCLUDE_FULLY_COMPLETE: "Tamamlanm\u0131\u015F PIP'leri dahil et",
  INDICATES_REQUIRED_FIELD: "Gerekli alan\u0131 g\xF6sterir",
  INFO_MESSAGE_TITLE: "Bir sistem bildirimi g\xF6nderildi:",
  INFO_MESSAGES: "Bilgi Mesajlar\u0131",
  INFO_MESSAGES_TITLE: "Birden fazla sistem bildirimi g\xF6nderildi:",
  INFO_REQUEST_STATUS_ERROR: "Bilgi istek ile g\xF6nderilmeye haz\u0131rd\u0131r.",
  INFORMATION: "Bilgi",
  INFORMATION_REQUEST: "Bilgi \u0130ste\u011Fi",
  INFORMATION_REQUEST_STATUS: "Bilgi \u0130ste\u011Fi Durumu",
  INPUT_PIN: "Giri\u015F PIN'i",
  INSPECTION: "\u0130nceleme",
  INSTALLED_BY: "Kurulumu Yapan",
  INSTALLED_BY_IS_REQUIRED: "Kuran Ki\u015Fi gereklidir",
  INTERNAL_DEERE_COMMENTS: "Deere Yorumlar\u0131 (dahili)",
  INTERVAL_BEGINS: "Aral\u0131k Ba\u015Flang\u0131c\u0131",
  INTERVAL_ENDS: "Aral\u0131k Biti\u015Fi",
  INTERVAL_TYPE_DESCRIPTION: "Aral\u0131k T\xFCr\xFC A\xE7\u0131klamas\u0131",
  INVOICE_ACCOUNT: "Fatura Hesab\u0131",
  INVOICE_DEALER: "Faturalayan Bayi",
  INVOICE_NUMBER: "Fatura Numaras\u0131",
  INVOICE_REQUEST: "Fatura \u0130ste\u011Fi",
  INVOICE_SENT: "Fatura G\xF6nderildi",
  INVOICE_UPDATED_SUCCESSFULLY: "Fatura Ba\u015Far\u0131yla G\xFCncellendi",
  INVOICED: "Fatural\u0131",
  INVOICED_TO: "Fatura al\u0131c\u0131s\u0131",
  IRC_PIN_MESSAGE: "M\xFC\u015Fteri bir IRC'dir ve ilk 500 saat veya 12 ayl\u0131k makine m\xFClkiyeti i\xE7in \xFCcretsiz Seyahat S\xFCresi ve Mesafe bilgilerini almaya yetkilidir.",
  ISSUED: "Yay\u0131n Tarihi",
  ITALIAN: "\u0130talyanca",
  ITEM: "\xD6\u011Feleri",
  ITEM_NUMBER: "Kalem Numaras\u0131",
  ITEM_NUMBER_IS_REQUIRED: "\xD6\u011Fe Numaras\u0131 gereklidir",
  JDLINK_EXPIRES: "JDLink S\xFCre Sonu",
  JDP_COMMENTS: "JDP Yorumlar\u0131",
  JDP_COMMENTS_IS_REQUIRED: "JDP Yorumlar\u0131 gereklidir",
  JDP_CUSTOMER_RESOLUTION: "JDP M\xFC\u015Fteri \xC7\xF6z\xFCm\xFC",
  JDP_CUSTOMER_RESOLUTION_IS_REQUIRED: "JDP M\xFC\u015Fteri \xC7\xF6z\xFCm\xFC gereklidir",
  JDP_REASON: "JDP Nedeni",
  JDP_REASON_IS_REQUIRED: "JDP Nedeni gereklidir",
  LABOR: "\u0130\u015F\xE7ilik",
  LABOR_ADDITIVE: "\u0130\u015F\xE7ilik \u0130lavesi",
  LABOR_ADDITIVE_COMPLETION_DETAIL: "\u0130\u015F\xE7ilik \u0130lavesi Tamamlama Detay\u0131",
  LABOR_ADDITIVE_PIPS: "\u0130\u015F\xE7ilik \u0130lavesi PIP'leri",
  LABOR_ADDITIVE_TAB: "\u0130\u015F\xE7ilik \u0130lavesi ({count})",
  LABOR_ADJUSTMENT: "\u0130\u015F\xE7ilik Ayar\u0131",
  LABOR_COMMENTS: "\u0130\u015F\xE7ilik Yorumlar",
  LABOR_HOURS: "\u0130\u015F\xE7ilik Saati",
  LABOR_ITEM_DETAILS: "\u0130\u015F G\xFCc\xFC - {quantity} {unit} {description}",
  LABOR_RATE_APPROVED_SUCCESSFULLY: "\u0130\u015F\xE7ilik \xDCcreti Ba\u015Far\u0131yla Onayland\u0131",
  LABOR_RATE_CHANGE_SUBMITTED: "\u0130\u015F\xE7ilik \xDCcreti De\u011Fi\u015Fikli\u011Fi G\xF6nderildi",
  LABOR_RATE_CHANGES_WITH_COUNT: "\u0130\u015F\xE7ilik \xDCcreti De\u011Fi\u015Fiklikleri ({count})",
  LABOR_RATE_CONFIRM: "\u0130stenen \xFCcret, ge\xE7erli \xFCcretten daha d\xFC\u015F\xFCk.  \u0130ste\u011Fi g\xF6ndermek istedi\u011Finizden emin misiniz?",
  LABOR_RATE_DIFFERENCE_LARGE_INFORMATION_MESSAGE: "K\u0131rm\u0131z\u0131 metindeki oranlar, mevcut h\u0131zdan %10'dan fazla bir art\u0131\u015F oldu\u011Funu g\xF6sterir",
  LABOR_RATE_HISTORY: "\u0130\u015F\xE7ilik \xDCcreti Ge\xE7mi\u015Fi",
  LABOR_RATE_REJECTED_SUCCESSFULLY: "\u0130\u015F\xE7ilik \xDCcreti Ba\u015Far\u0131yla Reddedildi",
  LABOR_RATE_REQUESTS_STATUS: "\u0130\u015F\xE7ilik Oran\u0131 \u0130stekleri Durumu",
  LABOR_RATE_RETURNED_SUCCESSFULLY: "\u0130\u015F\xE7ilik \xDCcreti Ba\u015Far\u0131yla \u0130ade Edildi",
  LABOR_RATES: "\u0130\u015F\xE7ilik \xDCcretleri",
  LABOR_STATS: "\u0130\u015F\xE7ilik \u0130statistikleri",
  LABOR_TOTAL: "\u0130\u015F\xE7ilik Toplam\u0131",
  LABOR_TYPE: "\u0130\u015F\xE7ilik T\xFCr\xFC",
  LABOR_VALUE: "\u0130\u015F\xE7ilik De\u011Feri",
  LABOR_WITH_COUNT: "\u0130\u015F\xE7ilik ({count})",
  LANGUAGE: "Dil",
  LAST_LOCATION_FROM: "Son Konum",
  LAST_NAME: "Soyad\u0131",
  LAST_NAME_IS_REQUIRED: "Soyad\u0131 gereklidir",
  LAST_PERSONAL_CONTACT: "Son Ki\u015Fisel \u0130li\u015Fki",
  LAW_ENFORCEMENT_AGENCY_DETAILS: "Emniyet Te\u015Fkilat\u0131 Detaylar\u0131",
  LAYOUT_CREATED_SUCCESSFULLY: "Mizanpaj ba\u015Far\u0131yla olu\u015Fturuldu",
  LAYOUT_DELETED_SUCCESSFULLY: "Mizanpaj ba\u015Far\u0131yla silindi",
  LAYOUT_NAME: "Mizanpaj isim",
  LAYOUT_UPDATED_SUCCESSFULLY: "Mizanpaj ba\u015Far\u0131yla g\xFCncellendi",
  LEAD_ACCOUNT: "\xD6nc\xFC Hesap",
  LEAD_DEALER: "Lider Bayi",
  LESS_THAN: "Daha az",
  LESS_THAN_OR_EQUALS: "Daha az veya e\u015Fitlik",
  LICENSE_PLATE_NUMBER: "Plaka Numaras\u0131",
  LIFETIME: "\xD6m\xFCr Boyu",
  LINE_ITEMS_EXPORT: "Sat\u0131r \xD6\u011Feleri \u0130hracat",
  LIST: "Liste",
  LIST_TOTAL: "Toplam Liste",
  LOCATION: "Yer",
  LOCATION_DUE: "Konum Vade Tarihi",
  LOCATIONS: "Konumlar",
  LOCATIONS_WITH_COUNT: "Konum ({count})",
  MACHINE_ALREADY_REGISTERED_TO_THIS_CUSTOMER: "Makine zaten bu m\xFC\u015Fteriye kaydedilmi\u015F",
  MACHINE_INFORMATION: "Makine Bilgileri",
  MACHINE_MODEL_TYPE: "Makine Modeli/Tipi",
  MACHINE_MODEL_TYPE_REQUIRED: "Makine Modeli/Tipi Gerekli",
  MACHINE_STATUS: "Makine Durumu",
  MACHINE_STATUS_UPDATE_ACCEPTED: "Makine Durumu G\xFCncellemesi Kabul Edildi",
  MACHINE_STATUS_UPDATE_DOCUMENT: "Makine Durumu G\xFCncelleme Belgesi",
  MACHINE_STATUS_UPDATE_REJECTED: "Makine Durumu G\xFCncellemesi Reddedildi",
  MACHINE_STATUS_UPDATES_WITH_COUNT: "Makine Durumu G\xFCncellemeleri ({count})",
  MACHINE_TYPE: "Makine T\xFCr\xFC",
  MACHINE_TYPE_IS_REQUIRED: "Makine T\xFCr\xFC gereklidir",
  MACHINE_USE: "Makine Kullan\u0131m\u0131",
  MAILING_RECIPIENT: "Posta Al\u0131c\u0131s\u0131 (Ad ve Soyad\u0131)",
  MAILING_RECIPIENT_REQUIRED: "Posta Al\u0131c\u0131s\u0131 Gerekli",
  MAINTENANCE: "Bak\u0131m",
  MAINTENANCE_PLAN: "Bak\u0131m Planlar\u0131",
  MAINTENANCE_PLAN_INFO: "Bak\u0131m Plan\u0131 Bilgileri",
  MARK_AS_REVIEW: "G\xF6zden Ge\xE7irildi Olarak \u0130\u015Faretle",
  MARKETING_INCENTIVE: "Pazarlama - \xF6zendirici",
  MARKETING_JD_PROMISE: "Pazarlama - JD Taahh\xFCd\xFC",
  MARKETING_MAINTENANCE_PLAN: "Pazarlama - Bak\u0131m Plan\u0131",
  MARKETING_MASS_CHANNEL_FOLLOWUP: "Pazarlama - Toplu Kanal Takibi",
  MARKETING_MASS_CHANNEL_PDI: "Pazarlama - Toplu Kanal PDI's\u0131",
  MASS_CHANNEL_CUSTOMER_FOLLOW_UP: "Toplu Kanal M\xFC\u015Fterisi Takibi",
  MASS_CHANNEL_CUSTOMER_FOLLOW_UP_HELP_TEXT: "Hat\u0131rlat\u0131c\u0131, l\xFCtfen Sat\u0131\u015F Arama Program\u0131 Sonras\u0131 Takibinizi uygulamadan \xF6nce eyaletinizdeki ve federal d\xFCzeydeki uygun #Arama Yapma# prosed\xFCrlerini belirlemek i\xE7in kendi yasal dan\u0131\u015Fman\u0131n\u0131z ile ileti\u015Fime ge\xE7ti\u011Finizden emin olun",
  MASS_CHANNEL_PDI_CLAIM: "Toplu Kanal PDI's\u0131",
  MASTER_WARRANTY_TYPE: "Ana Garanti T\xFCr\xFC",
  MATERIAL: "Malzeme Numaras\u0131",
  MERCHANDISE: "Ticari \xDCr\xFCn",
  MESSAGE: "Mesaj",
  MESSAGES: "Mesajlar",
  METHOD_OF_CONTACT: "\u0130rtibat Y\xF6ntemi",
  METHOD_OF_CONTACT_IS_REQUIRED: "\u0130rtibat Y\xF6ntemi gereklidir",
  METRIC: "Metrik",
  METRICS: "\xD6l\xE7\xFCmler",
  MILEAGE_LIMIT: "D\xF6nem S\u0131n\u0131r\u0131",
  MOBILE_PHONE: "Cep Telefonu",
  MODEL: "Model",
  MODEL_NUMBER: "Model Numaras\u0131",
  MODIFIED: "De\u011Fi\u015Ftirildi",
  MONTH_TO_DATE: "Ay Ba\u015F\u0131ndan Bug\xFCne Kadar",
  MORE: "Daha",
  MULTIPLE: "Birden \xE7ok",
  NAME: "Ad",
  NET: "Net",
  NET_AMOUNT: "Net Tutar",
  NET_AMOUNT_PAID: "Net Tutar \xD6dendi",
  NET_TOTAL: "Net toplam",
  NEW: "YEN\u0130",
  NEW_ACCOUNT: "Yeni Hesap",
  NEW_CLAIM: "Yeni iddia",
  NEW_CLAIM_VALUE: "Yeni Talep De\u011Feri",
  NEW_CUSTOMER_REQUIRED: "Yeni M\xFC\u015Fteri gerekiyor",
  NEW_DEALER: "Yeni Bayi",
  NEW_DEALER_DISTANCE: "Yeni Sat\u0131c\u0131 Uzakl\u0131\u011F\u0131",
  NEW_DEALER_LOCATION: "Yeni Bayi Konumu",
  NEW_LABOR_RATE: "Yeni \u0130\u015F\xE7ilik \xDCcreti",
  NEW_REQUEST_ENTER_RATES: "Yeni Talep - Oranlar\u0131 Girin",
  NEW_STATUS: "Yeni Durum",
  NEW_TRANSFER: "Yeni Transfer",
  NEW_TRANSFER_CREATED: "Yeni Transfer Olu\u015Fturuldu",
  NEW_VALUE: "Yeni De\u011Fer",
  NO: "Hay\u0131r",
  NO_ACTIVE_WARRANTY: "Aktif Garanti Yok",
  NO_AFFECTED_PINS: "Bayilik sorumlulu\u011Funuz alt\u0131nda etkilenen hi\xE7bir PIN mevcut de\u011Fil",
  NO_AUTHORITY_TO_ACCESS: "JDWS'a eri\u015Fim yetkiniz yok. Kat\u0131l\u0131mc\u0131 kullan\u0131c\u0131lar\u0131 otoriteyi do\u011Frulamak i\xE7in Profil Y\xF6neticinize (DPA) ba\u015Fvurun ve Deere kullan\u0131c\u0131lar\u0131 bu hatan\u0131n bir kopyas\u0131yla Destek birimine ba\u015Fvurun",
  NO_CLAIMS: "Hi\xE7bir talep yok.",
  NO_CUSTOMER_ASSOCIATED: "\u0130li\u015Fkilendirilmi\u015F M\xFC\u015Fteri Yok",
  NO_CUSTOMER_SELECTED: "Hi\xE7bir M\xFC\u015Fteri Se\xE7ilmedi",
  NO_DEALER_INVOICES: "Bayi Faturas\u0131 Yok",
  NO_DEALERS_MAPPED: "Kullan\u0131c\u0131 Kimli\u011Fine e\u015Flenmi\u015F hi\xE7bir bayiniz yoktur. L\xFCtfen sistem y\xF6neticiniz ile ileti\u015Fime ge\xE7in.",
  NO_IF_NO_A_PICTURE_MUST_BE_PROVIDED_AS_EVIDENCE: "Hasar foto\u011Fraf\u0131 gerekli de\u011Fil, l\xFCtfen talebe ekleyin.",
  NO_INFORMATION_AVAILABLE_FOR_THIS_PRODUCT: "Bu \xDCr\xFCn icin herhangi bir bilgi bulunmamaktad\u0131r",
  NO_LOWERCASE: "Yok",
  NO_MATCHING_DEALERS: "Filtre metni ile e\u015Fle\u015Fen hi\xE7bir bayi yok.",
  NO_OPEN_PART_REQUESTS: "Par\xE7a \u0130ste\u011Fi Yok",
  NO_OPEN_PIPS: "A\xE7\u0131k PIP Yok",
  NO_PARTS_RETURNED: "Hi\xE7bir Par\xE7a \u0130ade Edilmedi",
  NO_PIP_PRODUCTS: "Hi\xE7bir PIP \xFCr\xFCn\xFC mevcut de\u011Fil.",
  NO_PRODUCT_FOUND: "Hi\xE7bir \xDCr\xFCn Bulunamad\u0131",
  NO_REQUIRED_ITEMS: "Gereken \xF6\u011Fe yok.",
  NO_RESULTS: "Sonu\xE7 Yok",
  NO_RESULTS_FOUND: "Hi\xE7bir Sonu\xE7 Bulunamad\u0131",
  NO_ROWS_TO_SHOW: "Gostermek icin satir yok",
  NO_SPECIAL_INSTRUCTIONS: "\xD6zel talimat yok.",
  NO_TRAVEL: "Yol\xE7uluk Yok",
  NON_RECOVERABLE_TAXES: "Geri D\xF6nd\xFCr\xFClemez Vergiler",
  NON_TRACKED_PINS_HELP_TEXT: "Kay\u0131t sonras\u0131na kadar baz\u0131 \xFCr\xFCnler Garanti'de g\xF6r\xFCnm\xFCyor. Araman\u0131z, bu \xFCr\xFCnler aral\u0131\u011F\u0131 ile e\u015Fle\u015Fiyor.",
  NON_TRAVEL: "Seyahat D\u0131\u015F\u0131",
  NONE: "Yok",
  NORMAL: "NORMAL",
  NOT_EQUAL: "e\u015Fit de\u011Fildir",
  NOTIFICATION_ADDED_SUCCESSFULLY: "Bildirim ba\u015Far\u0131yla eklendi",
  NOTIFICATION_DELETED_SUCCESSFULLY: "Bildirim Ba\u015Far\u0131yla Silindi",
  NOTIFICATION_SEQUENCE_UPDATED_SUCCESSFULLY: "Bildirim s\u0131ras\u0131 ba\u015Far\u0131yla g\xFCncellendi",
  NOTIFICATION_UPDATED_SUCCESSFULLY: "Bildirim ba\u015Far\u0131yla g\xFCncellendi",
  NOTIFICATIONS: "Bildirimler",
  NUMBER_OF_DIAGNOSTICS_OCCURRENCES: "Ditagnostik Olaylar\u0131n\u0131n Say\u0131s\u0131",
  NUMBER_OF_OPEN_PIPS: "{number} A\xE7\u0131k PIP",
  NUMBER_OF_REPAIR_OCCURRENCES: "Tamir Olaylar\u0131n\u0131n Say\u0131s\u0131",
  NUMBER_OF_REPLACEMENT_OCCURRENCES: "De\u011Fi\u015Fiklik Olaylar\u0131n\u0131n Say\u0131s\u0131",
  OLD_LABOR_RATE: "Eski \u0130\u015F\xE7ilik \xDCcreti",
  ON_SHELF: "Rafta",
  ON_SHELF_COST: "Raf Maliyeti",
  ONE_ITEM_MUST_BE_SELECTED: "Bir \xF6\u011Fenin se\xE7ilmesi gerekir",
  OPEN: "A\xE7\u0131k",
  OPEN_PART_REQUESTS: "A\xE7\u0131k Par\xE7a Talepleri",
  OPEN_PART_REQUESTS_WITH_COUNT: "A\xE7\u0131k Par\xE7a Talebi ({count})",
  OPEN_PIP_COUNT: "PIP Say\u0131s\u0131n\u0131 A\xE7",
  OPEN_PIP_PROGRAMS: "PIP Kayd\u0131",
  OPEN_PIPS: "Tamamlanmam\u0131\u015F PIP'ler",
  OPEN_PIPS_REPORT: "Tamamlanmam\u0131\u015F PIP Raporu",
  OPEN_PIPS_TAB: "A\xE7\u0131k PIP'ler ({count})",
  OPERATORS_COMPLAINT: "Operat\xF6r\xFCn \u015Fikayeti neydi?",
  OPERATORS_COMPLAINT_IS_REQUIRED: "Operat\xF6r\xFCn \u015Fikayeti gereklidir",
  OPERATORS_MANUAL_NUMBER: "Kullan\u0131c\u0131 El Kitab\u0131 Numaras\u0131",
  OPTION_CODE: "Se\xE7im Kodu",
  OPTION_CODE_CREATED_SUCCESSFULLY: "Se\xE7im Kodu Ba\u015Far\u0131yla Yarad\u0131ld\u0131",
  OPTION_CODE_DELETED_SUCCESSFULLY: "Se\xE7im Kodu Ba\u015Far\u0131yla Silindi",
  OPTION_CODES: "Se\xE7enek Kodlar\u0131",
  OR: "veya",
  ORIGINAL_CLAIM_VALUE: "Orijinal Talep De\u011Feri",
  ORIGINAL_SUBMISSION_DATE: "Orijinal G\xF6nderim Tarihi",
  ORIGINALLY_SUBMITTED: "Orijinal Olarak G\xF6nderildi",
  OTHER: "Di\u011Fer",
  OTHER_AMOUNT_OF_USE: "Di\u011Fer Kullan\u0131m Miktar\u0131",
  OTHER_AMOUNT_OF_USE_REQUIRED: "Di\u011Fer Gerekli Kullan\u0131m Miktar\u0131",
  OTHER_CREDIT: "Di\u011Fer Alacak",
  OTHER_CREDIT_1: "Di\u011Fer Alacak 1",
  OTHER_CREDIT_2: "Di\u011Fer Alacak 2",
  OTHER_CREDIT_3: "Di\u011Fer Alacak 3",
  OTHER_CREDIT_ADJUSTMENT: "Di\u011Fer Alacak Ayar\u0131",
  OTHER_CREDIT_ITEM_DETAILS: "Di\u011Fer Alacak - {description} ({quantity} {unit})",
  OTHER_CREDIT_TOTAL: "Di\u011Fer Alacak toplam\u0131",
  OTHER_CREDITS: "Di\u011Fer Alacaklar",
  OTHER_CREDITS_WITH_COUNT: "Di\u011Fer Krediler ({count})",
  OTHER_INSTRUCTIONS: "Di\u011Fer Talimatlar",
  OUTPUT_PIN: "\xC7\u0131kt\u0131 PIN",
  OVERDUE: "Gecikmi\u015F",
  OVERRIDE_ACCOUNT: "Hesab\u0131 Ge\xE7ersiz K\u0131l",
  OVERRIDE_EFFECTIVE_DATE: "Ge\xE7ersiz K\u0131lma Etkinlik Tarihi",
  OVERRIDE_SUGGESTED_ACCOUNT: "\xD6nerilen Hesab\u0131 Ge\xE7ersiz K\u0131l",
  OWNERSHIP_STATUS: "Sahiplik Durumu",
  OWNERSHIP_STATUS_IS_REQUIRED: "Sahiplik Durumu gereklidir",
  PART: "Par\xE7a",
  PART_1: "Par\xE7a 1",
  PART_2: "Par\xE7a 2",
  PART_3: "Par\xE7a 3",
  PART_4: "Par\xE7a 4",
  PART_5: "Par\xE7a 5",
  PART_6: "Par\xE7a 6",
  PART_7: "Par\xE7a 7",
  PART_8: "Par\xE7a 8",
  PART_9: "Par\xE7a 9",
  PART_10: "Par\xE7a 10",
  PART_AMONT_OF_USE: "Par\xE7a Kullan\u0131m Miktar\u0131",
  PART_FAMILY: "Par\xE7a Ailesi",
  PART_ITEM_DETAILS: "Par\xE7alar - {quantity} {description} Par\xE7a No {partNumber}",
  PART_NUMBER: "Par\xE7a Numaras\u0131",
  PART_REQUEST: "Par\xE7a \u0130ste\u011Fi",
  PART_REQUEST_NUMBER: "Par\xE7a Talebi {rgaNumber}",
  PART_REQUEST_STATUS: "Par\xE7a Talebi Durumu",
  PART_REQUESTS: "Par\xE7a \u0130stekleri",
  PART_REQUESTS_SEARCH_BY_CLAIM_PLACEHOLDER: "Kleym Numaras\u0131n\u0131 Gir, Minimum 4 Karakter",
  PART_REQUESTS_SEARCH_BY_CLAIM_VALIDATION_ERROR: "Kleym aramas\u0131n\u0131n en az 4 karakter olmas\u0131 gerekir",
  PART_REQUESTS_SEARCH_BY_DTAC_CASE_NUMBER_ERROR: "DTAC Vaka Numaras\u0131 aramas\u0131n\u0131n tam DTAC Vaka Numaras\u0131 olmas\u0131 gerekir, en az 4 karakter",
  PART_REQUESTS_SEARCH_BY_DTAC_CASE_NUMBER_PLACEHOLDER: "Tam DTAC Vaka Numaras\u0131n\u0131 Gir",
  PART_REQUESTS_SEARCH_BY_PART_NUMBER_ERROR: "Par\xE7a Numaras\u0131 aramas\u0131n\u0131n en az 4 karakter olmas\u0131 gerekir",
  PART_REQUESTS_SEARCH_BY_PART_NUMBER_PLACEHOLDER: "Par\xE7a Numaras\u0131n\u0131 Gir, minimum 4 Karakter",
  PART_REQUESTS_SEARCH_BY_PART_REQUEST_ERROR: "Par\xE7a \u0130stek Numaras\u0131 aramas\u0131n\u0131n en az 4 karakter olmas\u0131 gerekir",
  PART_REQUESTS_SEARCH_BY_PART_REQUEST_PLACEHOLDER: "Par\xE7a \u0130stek Numaras\u0131n\u0131 Gir, minimum 4 Karakter",
  PART_REQUESTS_SEARCH_BY_PIN_ERROR: "PIN Aramas\u0131n\u0131n en az 4 karakter olmas\u0131 gerekir",
  PART_REQUESTS_SEARCH_BY_PIN_PLACEHOLDER: "PIN'i Gir, minimum 4 Karakter",
  PART_REQUESTS_SEARCH_BY_WORK_ORDER_ERROR: "\u0130\u015F Emri aramas\u0131n\u0131n tam \u0130\u015F Emri olmas\u0131 gerekir, en az 2 karakter",
  PART_REQUESTS_SEARCH_BY_WORK_ORDER_PLACEHOLDER: "Tam \u0130\u015F Emrini Gir",
  PART_REQUESTS_UPDATED_SUCCESSFULLY: "Par\xE7a \u0130ste\u011Fi ba\u015Far\u0131yla g\xFCncellendi",
  PART_RETURN: "Par\xE7a \u0130adesi",
  PART_RETURNS: "Par\xE7a \u0130adeleri",
  PART_SERIAL_NUMBER: "Par\xE7a Seri Numaras\u0131",
  PART_SERIAL_NUMBER_IS_REQUIRED: "Par\xE7a Seri Numaras\u0131 gereklidir",
  PART_TOTAL: "Par\xE7a Toplam\u0131",
  PART_TYPE: "Par\xE7a T\xFCr\xFC",
  PART_USE: "Par\xE7a Kullan\u0131m\u0131",
  PART_VALUE: "Par\xE7a De\u011Feri",
  PARTIAL_DEBIT: "K\u0131smi Bor\xE7",
  PARTICIPANT: "Kat\u0131l\u0131mc\u0131",
  PARTS: "PAR\xC7ALAR",
  PARTS_ADDITIVE: "Par\xE7a \u0130lavesi",
  PARTS_ADJUSTMENT: "Par\xE7a Ayar\u0131",
  PARTS_COVERAGE_SEARCH: "Par\xE7a Kapsam\u0131 Aramas\u0131",
  PARTS_TEMPLATE: "Par\xE7a \u015Eablonu",
  PARTS_USE: "Par\xE7a Kullan\u0131m",
  PARTS_USE_IS_REQUIRED: "Par\xE7alar\u0131n Kullan\u0131m\u0131 gereklidir",
  PARTS_WITH_COUNT: "Par\xE7alar ({count})",
  PARTS_WITH_PARENTHESES: "Par\xE7a(lar)",
  PAST_DUE: "S\xFCre Sona Erdi",
  PAYER_ACCOUNT: "\xD6deyen Hesab\u0131",
  PERCENT_COMPLETE: "Tamamlanan Y\xFCzde",
  PERCENTAGE: "Y\xFCzde",
  PERCENTAGE_DEBIT: "Y\xFCzde Bor\xE7",
  PERCENTAGE_SYMBOL: "%{percentage}",
  PERCENTAGE_TO_DEBIT: "Bor\xE7 Y\xFCzdesi",
  PERMANENTLY_OUT_OF_SERVICE_MACHINES_HELP_TEXT: "Servis d\u0131\u015F\u0131 makineler i\xE7in, makinenin gelecekteki herhangi bir noktada yeniden olu\u015Fturulamayaca\u011F\u0131n\u0131, onar\u0131lamayaca\u011F\u0131n\u0131 veya kullan\u0131lamayaca\u011F\u0131n\u0131 do\u011Frulamak \xFCzere makinenin bir resmini ekleyin. Hizmet d\u0131\u015F\u0131 kalan makineler, PIP'ler i\xE7in her t\xFCrl\xFC yeterlili\u011Fe sahip de\u011Fildir.",
  PERSON_RESPONSIBLE: "Sorumlu Ki\u015Fi",
  PHONE: "TELEFON",
  PHONE_REQUIRED: "Telefon Gerekli",
  PICTURE: "g\xF6r\xFCnt\xFC",
  PICTURE_REQUEST: "Resim \u0130ste\u011Fi",
  PICTURE_REQUEST_STATUS: "Resim \u0130ste\u011Fi Durumu",
  PICTURE_REQUEST_STATUS_ERROR: "Ekler bu istek ile g\xF6nderilmeye haz\u0131r.",
  PIN: "PIN",
  PIN_CREATED_SUCCESSFULLY: "PIN Ba\u015Far\u0131yla Olu\u015Fturuldu",
  PIN_CROSS_REFERENCE: "PIN \xC7apraz Referans",
  PIN_INVALID: "PIN Ge\xE7ersiz",
  PIN_IS_REQUIRED: "Pin, gereklidir",
  PIN_REQUIRED: "PIN Gerekli",
  PIN_SEARCH: "Aramay\u0131 Sabitle",
  PIN_SEARCH_INFORMATION: "Arama Bilgilerini Sabitle",
  PIN_TRANSFER_INFORMATION: "Pin Aktar\u0131m Bilgileri",
  PINS: "PIN'ler",
  PINS_NOT_REGISTERED: "PIN'ler Kay\u0131tl\u0131 De\u011Fil",
  PIP: "PIP",
  PIP_CODE: "PIP Kodu",
  PIP_CODE_CREATED_SUCCESSFULLY: "PIP kodu iste\u011Fi ba\u015Far\u0131yla olu\u015Fturuldu",
  PIP_CODE_REQUEST: "PIP Kodu Talebi",
  PIP_CODE_REQUEST_APPROVED: "PIP Kodu Talebi Onayland\u0131",
  PIP_CODE_REQUEST_REJECTED: "PIP Kodu Talebi Reddedildi",
  PIP_CODE_REQUESTS_WITH_COUNT: "PIP Kodu Talebi ({count})",
  PIP_COMPLETION_STATUS: "PIP Tamamlama Durumu",
  PIP_DETAILS: "PIP Ayr\u0131nt\u0131lar\u0131",
  PIP_HISTORY: "PIP Ge\xE7mi\u015Fi",
  PIP_ID: "PIP No",
  PIP_NUMBER: "PIP Numaras\u0131",
  PIP_PROGRAM: "PIP Program\u0131",
  PIP_PROGRAM_IS_REQUIRED: "PIP Program\u0131 gereklidir",
  PIP_PROGRAMS: "PIP Programlar\u0131",
  PIP_SEARCH: "PIP Aramas\u0131",
  PIP_STATUS: "PIP Durumu",
  PIP_TYPE: "PIP T\xFCr\xFC",
  PIP_TYPES: "PIP T\xFCrleri",
  PIPS: "PIP'ler",
  PIPS_UNPAID_LABOR_ADDITIVE: "\u0130\u015F\xE7ilik \u0130lavesi \xD6denmeyen PIP'ler",
  PLAN_DESCRIPTION: "Plan A\xE7\u0131klamas\u0131",
  PLAN_END_DATE: "Plan Biti\u015F Tarihi",
  PLAN_ENDS: "Plan Biti\u015Fleri",
  PLAN_NAME: "Plan Ad\u0131",
  PLAN_NAME_IS_REQUIRED: "Plan Ad\u0131 Gereklidir",
  PLAN_NAMES: "Plan Adlar\u0131",
  PLAN_START_DATE: "Plan Ba\u015Flang\u0131\xE7 Tarihi",
  PLAN_STARTS: "Plan Ba\u015Flang\u0131\xE7lar\u0131",
  PLANNED_BY: "Taraf\u0131ndan Planlanan",
  PLANT: "Tesis",
  PLATE_REQUEST_INFORMATION: "Plaka \u0130ste\u011Fi Bilgileri",
  PLEASE_SELECT_A_LEAD_ACCOUNT: "L\xFCtfen birincil bir hesap se\xE7in",
  PLEASE_SELECT_CLAIM_TYPE: "L\xFCtfen talep t\xFCr\xFCn\xFC se\xE7in",
  POLISH: "Leh\xE7e",
  PORTUGUESE: "Portekizce",
  POSTAGE_DELIVERY_DATE: "Posta Teslim Tarihi",
  POSTAL_CODE: "Posta Kodu",
  POSTAL_CODE_REQUIRED: "Posta Kodu Gerekli",
  POSTAL_TRACKING_NUMBER: "Posta Takip Numaras\u0131",
  POTENTIAL_RESPONSIBLE_DEALER: "Olas\u0131 Sorumlu Sat\u0131c\u0131",
  PRE_DELIVERY_INSPECTION: "Teslimat \xD6ncesi \u0130nceleme",
  PREFERRED_THEME: "Tercih Edilen Tema",
  PREPARE_AUDIT: "Denetim Haz\u0131rla",
  PREPARED: "Haz\u0131r",
  PREPARING_AUDIT_FOR_WITH_DEALER: "{dealer} \u0130\xE7in Denetim Haz\u0131rlama",
  PREVIOUS_AMOUNT_OF_USE: "\xD6nceki Kullan\u0131m Miktar\u0131",
  PREVIOUS_INVOICE_NUMBER: "\xD6nceki Fatura Numaras\u0131",
  PREVIOUS_INVOICE_NUMBER_IS_REQUIRED: "\xD6nceki Fatura Numaras\u0131 gereklidir",
  PREVIOUS_MONTH: "\xD6nceki Ay",
  PRICE: "Fiyat",
  PRICING_SUMMARY: "Fiyatland\u0131rma \xD6zeti",
  PRIMARY_ACTION: "Birincil \u0130\u015Flem",
  PRIMARY_LANGUAGE: "Birincil Dil",
  PRINT: "Yazd\u0131r",
  PRINT_CLAIM: "Kleymi Yazd\u0131r",
  PRINT_REGISTRATION_FORM: "Baski Kay\u0131t Formu",
  PRINT_REGISTRATION_FORM_MESSAGE: "\xDCr\xFCn\xFCn ilk sahibi \xFCzerine kay\u0131tl\u0131. \u015Fimdi kay\u0131t formunu yazd\u0131rmak istiyorsunuz?",
  PRINT_TO_PDF: "PDF Yazd\u0131r",
  PRIORITY: "\xD6ncelik",
  PRNT_CLM: "Iddian\u0131  G\xF6r\xFCnt\xFCle",
  PROCESS_DATE: "\u0130\u015Flem Tarihi",
  PROCESSED: "\u0130\u015Flendi",
  PROCESSED_PART_REQUESTS: "\u0130\u015Flenmi\u015F Par\xE7a \u0130stekleri",
  PROCESSING_STATUS: "\u0130\u015Flem Durumu",
  PROCESSING_STATUS_DESCRIPTION: "\u0130\u015Flem Durumu A\xE7\u0131klamas\u0131",
  PRODUCT_DETAILS: "\xDCr\xFCn Ayr\u0131nt\u0131lar\u0131",
  PRODUCT_HIERARCHY: "\xDCr\xFCn Hiyerar\u015Fi",
  PRODUCT_INFORMATION: "\xDCr\xFCn Bilgisi",
  PRODUCT_REGISTERED: "\xDCr\xFCn Kay\u0131tl\u0131",
  PRODUCT_REGISTRATION: "\xDCr\xFCn Kayd\u0131",
  PRODUCT_REGISTRATION_PENDED: "\xDCr\xFCn Kayd\u0131 Beklemede",
  PRODUCT_TRACKING: "\xDCr\xFCn \u0130zleme",
  PRODUCTS: "\xDCr\xFCnler",
  PRODUCTS_BY_CUSTOMER: "M\xFC\u015Fterilere G\xF6re \xDCr\xFCnleri",
  PRODUCTS_BY_CUSTOMER_PARTIAL_DATA_WARNING: "Ge\xE7ici bir sistem ba\u011Flant\u0131s\u0131 sorunu nedeniyle ge\xE7mi\u015F PIN'ler arama sonu\xE7lar\u0131nda eksik olabilir",
  PRODUCTS_WITH_COUNT: "\xDCr\xFCnler ({count})",
  PROGRAM: "Program",
  PROGRAM_DESCRIPTION: "Program A\xE7\u0131klamas\u0131",
  PROGRAM_IS_REQUIRED: "Program ad\u0131 gerekli.",
  PROGRAM_NAME: "Program Ad\u0131",
  PROGRAM_NAME_IS_REQUIRED: "Program ad\u0131 gerekli.",
  PROGRAM_NUMBER: "Program Say\u0131s\u0131",
  PRT: "PRT",
  PRTS: "PRT'ler",
  PURCHASE_INFO: "Sat\u0131n Alma Bilgileri",
  PURCHASE_ORDER: "Sat\u0131nalma Sipari\u015Fi",
  PURCHASE_ORDER_IS_REQUIRED: "Sat\u0131nalma Sipari\u015Fi gereklidir",
  PURCHASER_TYPE: "Al\u0131c\u0131 T\xFCr\xFC",
  PURCHASER_TYPE_REQUIRED: "Gereken Al\u0131c\u0131 T\xFCr\xFC",
  PUSH_XML: "XML'yi yeniden g\xF6nder",
  QTY: "Mkt.",
  QUALIFY_FOR_EMISSIONS: "Emisyon i\xE7in Yeterlilik Onay\u0131 Verin",
  QUANTITY: "Miktar",
  QUANTITY_1: "Miktar 1",
  QUANTITY_2: "Miktar 2",
  QUANTITY_3: "Miktar 3",
  QUANTITY_4: "Miktar 4",
  QUANTITY_5: "Miktar 5",
  QUANTITY_6: "Miktar 6",
  QUANTITY_7: "Miktar 7",
  QUANTITY_8: "Miktar 8",
  QUANTITY_9: "Miktar 9",
  QUANTITY_10: "Miktar 10",
  QUERY_MUST_CONTAIN_3_CHARACTERS: "Sorgunun en az 3 karakter i\xE7ermesi gerekir",
  QUEST_DESC: "Sorgulanabilir A\xE7\u0131klama",
  QUESTIONABLE_PART: "Sorgulanabilir Par\xE7a",
  QUEUED: "S\u0131raya Al\u0131nd\u0131",
  REASON_FOR_CHANGE: "De\u011Fi\u015Fiklik Nedeni",
  REASON_FOR_DEBIT: "Bor\xE7 Gerek\xE7esi",
  REASON_FOR_MISSING_PLATE: "Eksik Plakan\u0131n Nedeni",
  REASON_FOR_MISSING_PLATE_REQUIRED: "Eksik Plakan\u0131n Nedeni Gerekli",
  REASON_FOR_OVERRIDE: "Ge\xE7ersiz K\u0131lma Nedeni",
  REASON_FOR_REFUSAL: "Ret Nedeni",
  REASON_FOR_RETURN: "\u0130ade Nedeni",
  REASON_FOR_RETURN_IS_REQUIRED: "\u0130ade Nedeni gereklidir",
  REASON_FOR_TRANSFER: "Transfer Nedeni",
  REASON_FOR_TRANSFER_MUST_CONTAIN_ALPHANUMERIC_CHARACTERS: "Transfer Nedeni'nin alfasay\u0131sal karakterler i\xE7ermesi gerekir",
  RECIPIENT_DEALER_OR_TCSM: "Al\u0131c\u0131(Bayi veya TCSM)",
  RECIPIENT_MAILING: "Posta Al\u0131c\u0131s\u0131",
  RECONCILE: "Kar\u015F\u0131la\u015Ft\u0131r",
  RECONCILE_CLAIM: "Talebi Kar\u015F\u0131la\u015Ft\u0131r",
  RECONCILED: "MUTABAKAT",
  RECORD_AUDIT: "Denetimi Kaydet",
  RECORD_AUDIT_FOR: "{dealer} \u0130\xE7in Denetimi Kaydet",
  RECORDS_FOUND: "{countToDisplay} kay\u0131t bulundu",
  RECOVERABLE_TAXES: "D\xF6nd\xFCr\xFClebilir vergiler",
  RECOVERED: "Kurtar\u0131ld\u0131",
  RECOVERED_WITH_MISSED_ADDITIVES: "Eksik \u0130lavelerle Kurtar\u0131ld\u0131",
  RECOVERED_WITHOUT_ADDITIVES: "\u0130laveler Olmadan Kurtar\u0131ld\u0131",
  RECOVERY: "Kurtarma",
  RED_MUST_BE_LESS_THAN_YELLOW: "K\u0131rm\u0131z\u0131 G\xF6sterge De\u011Ferinin Sar\u0131 G\xF6sterge De\u011Ferinden D\xFC\u015F\xFCk Olmas\u0131 Gerekir",
  REFERENCE_1: "Referans 1",
  REFERENCE_2: "Referans 2",
  REFERENCE_INFORMATION: "Referans Bilgileri",
  REFERENCE_NUMBER1: "Referans Numaras\u0131 1",
  REFERENCE_NUMBER2: "Referans Numaras\u0131 2",
  REGION: "B\xF6lge",
  REGISTER: "Kaydet",
  REGISTER_A_PRODUCT_BY_PIN: "\xDCr\xFCn\xFC, PIN'e g\xF6re kaydedin",
  REGISTER_A_PRODUCT_TO_ADD: "Garanti sistemine eklemek icin \xDCr\xFCn\xFC  kaydet",
  REGISTER_ANOTHER_PRODUCT: "Ba\u015Fka Bir \xDCr\xFCn Kaydedin",
  REGISTER_PRODUCT: "\xDCr\xFCn Kayd\u0131n\u0131 Yap",
  REGISTER_PRODUCT_AND_REGISTER_ANOTHER: "Garanti sistemine eklemek icin \xDCr\xFCn\xFC kaydet",
  REGISTERED: "Kaydedildi",
  REGISTRATION: "Kay\u0131t",
  REGISTRATION_DATE: "Kay\u0131t Tarihi",
  REGISTRATION_DATES: "Kay\u0131t Tarihleri",
  REGISTRATION_FORM: "Kay\u0131t Formu",
  REGISTRATION_HISTORY: "Kay\u0131t Ge\xE7mi\u015Fi",
  REGISTRATION_NOT_ALLOWED: "Bu \xFCr\xFCn i\xE7in kayda izin verilmiyor",
  REGISTRATION_REVIEW: "Kay\u0131t \u0130nceleme",
  REGISTRATION_REVIEW_TAB: "Kay\u0131t \u0130nceleme ({count})",
  REGISTRATION_STATUS: "Kay\u0131t Durumu",
  REGISTRATION_STATUS_CANNOT_BE_NEW: "Kay\u0131t Durumu, Yeni olamaz",
  REGISTRATION_STATUS_REQUIRED: "Kay\u0131t Durumu gereklidir",
  REGISTRATION_SUCCESS: "Kay\u0131t Ba\u015Far\u0131l\u0131",
  REGISTRATION_TYPE: "Kay\u0131t T\xFCr\xFC",
  REGISTRATION_TYPE_CANNOT_BE_NEW: "Kay\u0131t T\xFCr\xFC, Yeni olamaz",
  REGISTRATION_TYPE_REQUIRED: "Gereken Kay\u0131t T\xFCr\xFC",
  REGISTRATION_UPDATED_SUCCESSFULLY: "Kay\u0131t ba\u015Far\u0131yla G\xFCncelle\u015Ftirildi",
  REGISTRATIONS_REVIEW: "Kay\u0131tlar\u0131 \u0130nceleme",
  REIMBURSED: "Geri \xD6dendi",
  REIMBURSED_AMOUNT: "Geri \xD6denen Tutar",
  REIMBURSED_PERCENTAGE: "Geri \xD6denen Y\xFCzde",
  REIMBURSED_PERCENTAGE_INDICATOR: "Geri \xD6denen Y\xFCzde G\xF6stergesi",
  REIMBURSEMENT_DETAILS: "Geri \xD6deme Detaylar\u0131",
  REIMBURSEMENT_PERCENTAGE: "Geri \xD6deme Y\xFCzdesi",
  REIMBURSEMENT_SUMMARY: "Geri \xD6deme \xD6zeti",
  REJECT: "Reddet",
  REJECT_LABOR_RATE: "\u0130\u015F\xE7ilik \xDCcretini Reddet",
  REJECT_SPECIAL_ALLOWANCE_CLAIM: "\xD6zel \xD6denek Kelymini Reddet",
  REJECTED: "REDDED\u0130LD\u0130",
  REJECTED_APPEAL: "REDDED\u0130LEN BA\u015EVURU",
  RELATIONSHIP: "\u0130li\u015Fki",
  RELATIONSHIP_IS_REQUIRED: "\u0130li\u015Fki gereklidir",
  REMOVE_FILTER: "Filtreyi Kald\u0131r",
  REMOVE_FROM_AUDIT: "Denetimden Kald\u0131r",
  REMOVE_LAYOUT: "Mizanpaj Kald\u0131r",
  RENTAL_PINS: "Kiralama PIN'leri",
  REPAIR_DATE: "Onar\u0131m Tarihi",
  REPAIR_DATE_CANNOT_BE_BEFORE_FAILURE_DATE: "Onar\u0131m tarihi, ba\u015Far\u0131s\u0131zl\u0131k tarihinden \xF6nce olamaz",
  REPAIR_NUMBER: "Onar\u0131m Numaras\u0131",
  REPAIR_NUMBER_IS_REQUIRED: "Tamir Numaras\u0131 gereklidir",
  REPAIR_REPLACE_INDICATOR: "Onar/De\u011Fi\u015Ftir G\xF6stergesi",
  REPAIRED: "Onar\u0131ld\u0131",
  REPAIRED_DATE: "Tamir Edildi\u011Fi Tarih",
  REPAIRED_DATE_CANNOT_BE_BEFORE_FAILED_DATE: "Tamir edildi\u011Fi tarih, ba\u015Far\u0131s\u0131z tarihinden \xF6nce olamaz",
  REPAIRED_DATE_IS_REQUIRED: "Tamir Edildi\u011Fi Tarih gereklidir",
  REPORT_DATE: "Rapor Tarihi",
  REPORT_NUMBER: "Rapor Numaras\u0131",
  REPORTS: "Raporlar",
  REQ_ADDL: "Alaca\u011F\u0131 D\xFCzelt",
  REQUEST_DATE: "Talep tarihi",
  REQUEST_DETAILS: "\u0130stek Detaylar\u0131",
  REQUEST_DUPLICATE_PIN_PLATE: "Yinelenen PIN Plakas\u0131 \u0130ste",
  REQUEST_FORM: "Talep Formu",
  REQUEST_PIP_CODE: "\u0130stek PIP Kodu",
  REQUEST_STATUS: "Istek durumu",
  REQUEST_SUBMITTED: "Talep G\xF6nderildi",
  REQUEST_TYPE: "\u0130stek T\xFCr\xFC",
  REQUEST_UPDATED_SUCCESSFULLY: "Ba\u015Far\u0131yla G\xFCncellendi Talep Edildi",
  REQUEST_WARRANTY_CLAIM_DEBIT: "Garanti Kleymli Bor\xE7 Talep Et",
  REQUESTED: "\u0130stendi",
  REQUESTED_BY: "Talep Eden",
  REQUESTED_DATE: "Talep tarihi",
  REQUESTED_DATES: "Talep Tarihleri",
  REQUESTED_DIAGNOSTIC_AMOUNT: "Talep Edilen Te\u015Fhis Miktar\u0131",
  REQUESTED_DIAGNOSTIC_HOURS: "Talep Edilen Te\u015Fhis Saatleri",
  REQUESTED_LABOR_AMOUNT: "Talep Edilen \u0130\u015F\xE7ilik Miktar\u0131",
  REQUESTED_LABOR_HOURS: "Talep Edilen \u0130\u015F\xE7ilik Saati",
  REQUESTED_OTHER_CREDITS: "\u0130stenen Di\u011Fer Alacaklar",
  REQUESTED_PARTS: "\u0130stenen Par\xE7alar",
  REQUESTED_REPAIR_AMOUNT: "Talep Edilen Onar\u0131m Tutar\u0131",
  REQUESTED_REPAIR_HOURS: "Talep Edilen Onar\u0131m Saatleri",
  REQUESTED_TRAVEL_TOTAL: "Talep Edilen Seyahat Toplam\u0131",
  REQUESTER_TCSM: "Talep sahibi (TCSM)",
  REQUESTER_TCSM_REQUIRED: "Talep Edilen (TCSM)",
  REQUIRED: "gereklidir",
  REQUIRED_CRITERIA: "Gerekli Kriterler",
  REQUIRED_ITEMS: "Gerekli \xD6\u011Feler",
  RESEND_XML: "XML'yi yeniden g\xF6nder",
  RESET: "S\u0131f\u0131rla",
  RESPONDENT_INFORMATION: "Yan\u0131t Veren Bilgileri",
  RESPONSIBILITY_OF: "Sorumluluk",
  RESPONSIBLE_ACCOUNT: "Sorumlu Hesap",
  RESPONSIBLE_ACCOUNT_IS_REQUIRED: "Sorumlu hesap gereklidir",
  RESPONSIBLE_DEALER: "Sorumlu Bayi",
  RET: "\u0130ade",
  RETAIL_INSTALL: "Perakende/Kurulum",
  RETAIL_INSTALL_DATE: "Perakende/Kurulum Tarihi",
  RETAIL_INSTALL_IS_REQUIRED: "Perakende/Kurulum gereklidir",
  RETAILER_NAME: "Perakendeci Ad\u0131",
  RETAILER_NAME_IS_REQUIRED: "Perakendeci Ad\u0131 gereklidir",
  RETRY: "yeniden deneyin",
  RETURN: "Geri \xC7evir",
  RETURN_LABOR_RATE: "\u0130\u015F\xE7ilik \u0130adesi",
  RETURN_REQUEST: "\u0130ade \u0130ste\u011Fi",
  RETURN_SPECIAL_ALLOWANCE_CLAIM: "\xD6zel \xD6denek Kleymini Geri \xC7evir",
  RETURN_STATUS: "\u0130ade Durumu",
  RETURNED: "\u0130ADE ED\u0130LD\u0130",
  RETURNED_DATE_CANNOT_BE_BEFORE_DELIVERED_DATE: "\u0130ade edildi\u011Fi tarih, teslim edildi\u011Fi tarihten \xF6nce olamaz",
  RETURNED_DATE_IS_REQUIRED: "\u0130ade edildi\u011Fi tarih gereklidir",
  REVIEW_DEALER_RECOMMENDATIONS: "\u0130nceleme i\xE7in i\u011Fneyi i\u015Faretlemek istedi\u011Finizden emin misiniz?",
  REVISE: "Revize Et",
  REVISED: "REV\u0130ZE ED\u0130LD\u0130",
  ROLLING_12_CREDIT_AMOUNT: "Toplam 12 Kredi Tutar\u0131",
  ROLLING_12_MONTHS: "12 Ay Boyunca",
  RUN_REPORT: "Raporu \xC7al\u0131\u015Ft\u0131r",
  RUSSIAN: "Rus\xE7a",
  SAP_DOWN_WARNING: "Garanti Sistemi i\u015Flevselli\u011Fi eksik. Bunu m\xFCmk\xFCn oldu\u011Fu kadar \xE7abuk d\xFCzeltmek i\xE7in \xE7al\u0131\u015F\u0131yoruz. Sistem kullan\u0131labilirli\u011Fini kontrol etmek i\xE7in taray\u0131c\u0131y\u0131 yenileyin.",
  SAVE: "Kaydet",
  SAVE_AS_DRAFT: "Taslak Olarak Kaydet",
  SAVE_AS_NEW_LAYOUT: "Yeni kaydet mizanpaj",
  SAVE_AUDIT: "Denetimi Kaydet",
  SAVE_CHANGES: "De\u011Fi\u015Fiklikleri Kaydet",
  SAVE_TO_VALIDATE: "Do\u011Frulamak i\xE7in Kaydet",
  SAVE_VALD: "Kaydet ve Do\u011Frula",
  SAVE_VALIDATE: "Kaydet ve Do\u011Frula",
  SEARCH: "Ara",
  SEARCH_BOX_PLACEHOLDER: "PIN, Seri No, Kleym No, DTAC Olay\u0131 veya M\xFC\u015Fteri Ad\u0131'n\u0131 girin",
  SEARCH_BY_CLAIM_TYPE: "Tam talep t\xFCr\xFCn\xFC girin",
  SEARCH_BY_CLAIM_TYPE_VALIDATION_FAIL: "Kleym aramas\u0131n\u0131n, tam talep t\xFCr\xFCne uygun olmas\u0131 gerekir, 4 ila 9 karakter",
  SEARCH_BY_FAILURE_PART_NUMBER: "Tam ar\u0131zal\u0131 par\xE7a numaras\u0131n\u0131 girin",
  SEARCH_BY_FAILURE_PART_NUMBER_VALIDATION_FAIL: "Talep aramas\u0131n\u0131n, tam ar\u0131zal\u0131 par\xE7a numaras\u0131na uygun olmas\u0131 gerekir, minimum 4 karakter.",
  SEARCH_BY_WORK_ORDER: "\u0130\u015F Emrini Gir, minimum 2 karakter",
  SEARCH_BY_WORK_ORDER_VALIDATION_FAIL: "\u0130\u015F Emri aramas\u0131n\u0131n minimum 2 karakter aras\u0131nda olmas\u0131 gerekir",
  SEARCH_PRODUCT_BY_CLAIM_PLACEHOLDER: "Tam Kleym numaras\u0131n\u0131 girin",
  SEARCH_PRODUCT_BY_CLAIM_VALIDATION_FAIL: "Kleym aramas\u0131n\u0131n, 4 ila 9 karakterden olu\u015Fan tam talep numaras\u0131 ile olmas\u0131 gerekir",
  SEARCH_PRODUCT_BY_COMPONENT_PLACEHOLDER: "Tam Bile\u015Fen seri numaras\u0131n\u0131 girin",
  SEARCH_PRODUCT_BY_COMPONENT_VALIDATION_FAIL: "Bile\u015Fen aramas\u0131n\u0131n en az 1 karakterli tam seri numaras\u0131 ile yap\u0131lmas\u0131 gerekir",
  SEARCH_PRODUCT_BY_FULL_PIN_PLACEHOLDER: "PIN girin",
  SEARCH_PRODUCT_BY_MODEL_PLACEHOLDER: "Tam Model numaras\u0131n\u0131 girin",
  SEARCH_PRODUCT_BY_MODEL_VALIDATION_FAIL: "Model aramas\u0131n\u0131n, 3 ila 12 karakterden olu\u015Fan tam model numaras\u0131 ile olmas\u0131 gerekir",
  SEARCH_PRODUCT_BY_PIN_PLACEHOLDER: "PIN'i Gir, minimum 6 karakter",
  SEARCH_PRODUCT_BY_PIN_VALIDATION_FAIL: "PIN aramas\u0131n\u0131n 6 ila 17 karakter aras\u0131nda olmas\u0131 gerekir",
  SEARCH_PRODUCT_BY_PIP_PLACEHOLDER: "Minimum 4 karakterdeki PIP Numaras\u0131'n\u0131 girin",
  SEARCH_PRODUCT_BY_PIP_VALIDATION_FAIL: "PIP aramas\u0131n\u0131 4 ila 12 karakterden olu\u015Fmal\u0131d\u0131r",
  SEARCH_RESULTS_TAB: "Arama Sonu\xE7lar\u0131 ({count})",
  SECOND_SHIP_TO_LOCATION: "\u0130kinci Sevk Yeri Konumu",
  SELECT: "Se\xE7",
  SELECT_A_RANGE: "Bir aral\u0131k se\xE7in",
  SELECT_ALL: "T\xFCm\xFCn\xFC Se\xE7",
  SELECT_AUTO_SUBMIT: "Otomatik G\xF6nder'i Se\xE7",
  SELECT_BRANCH: "\u015Eubeyi Se\xE7",
  SELECT_CLAIM_TYPE: "Kleym T\xFCr\xFCn\xFC Se\xE7",
  SELECT_COLUMNS: "S\xFCtunlar\u0131 Se\xE7",
  SELECT_COUNTRY: "\xDClkeyi Se\xE7",
  SELECT_CSV_SEPARATOR: "CSV Ay\u0131r\u0131c\u0131 se\xE7in",
  SELECT_DATE_FORMAT: "Tarih Format\u0131n\u0131 Se\xE7",
  SELECT_DEALERS_AND_STATUS: "Bayileri ve Durumu Se\xE7",
  SELECT_DECIMAL_FORMAT: "Ondal\u0131k Format\u0131 Se\xE7",
  SELECT_DISPLAY_FORMAT: "Ekran Format\u0131n\u0131 Se\xE7",
  SELECT_FACTORY: "Fabrikay\u0131 Se\xE7",
  SELECT_LANGUAGE: "Dili Se\xE7",
  SELECT_LAYOUT: "Mizanpaj Se\xE7",
  SELECT_PIP_CODE: "PIP Kodu Se\xE7",
  SELECT_PLAN_NAMES: "Plan Adlar\u0131n\u0131 Se\xE7",
  SELECT_SERVICE_INTERVAL_TYPES: "Servis Aral\u0131\u011F\u0131 T\xFCrlerini Se\xE7",
  SELECT_SORT_BY: "G\xF6re S\u0131rala Se\xE7",
  SELECT_SORT_DIRECTION: "S\u0131ralama Y\xF6n\xFC Se\xE7",
  SELECT_STATE: "Durumu Se\xE7",
  SELECT_STATUS: "Durum Se\xE7",
  SELECT_TERRITORY: "B\xF6lge Se\xE7",
  SELECT_THEME: "Temay\u0131 Se\xE7",
  SELECT_TIME_ZONE: "Zaman Dilimini Se\xE7",
  SELECT_VALUES_TO_APPROVE: "Onaylanacak De\u011Ferleri Se\xE7",
  SELECTED_COLUMNS: "S\xFCtunlar\u0131 Se\xE7ilmi\u015F",
  SELECTED_FOR_AUDIT: "Denetim i\xE7in Se\xE7ildi",
  SELECTED_FOR_AUDIT_VSR: "Bu talep i\xE7in gerekli denetim belgelerini ve ata\u015Fmanlar\u0131 i\xE7in DTAC \xC7\xF6z\xFCm\xFC 221475'e bak\u0131n",
  SELECTING_MULTIPLE_ACCOUNTS_AND_WARRANTY_TYPES_IMPACTS_PERFORMANCE: "Birden fazla Hesap ve Garanti T\xFCr\xFC se\xE7mek, performans\u0131 etkiler",
  SEND: "G\xF6nder",
  SERIAL_NUMBER: "Seri numaras\u0131",
  SERIAL_NUMBER_INVOICE_NUMBER: "Seri numaras\u0131 / Fatura numaras\u0131",
  SERVER_TOOK_TOO_LONG_TO_REPLY: "Sunucunun yan\u0131t vermesi \xE7ok uzun zaman ald\u0131 ve istek iptal edildi. L\xFCtfen daha belirgin bir istek deneyin ya da daha sonra tekrar deneyin.",
  SERVICE_DATE_IS_REQUIRED: "Servis Tarihi Gerekiyor",
  SERVICE_INTERVAL: "Servis Aral\u0131\u011F\u0131",
  SERVICE_INTERVAL_BEGIN_DATE: "Servis Aral\u0131\u011F\u0131 Ba\u015Flang\u0131\xE7 Tarihi",
  SERVICE_INTERVAL_END_DATE: "Servis Aral\u0131\u011F\u0131 Biti\u015F Tarihi",
  SERVICE_INTERVAL_IS_REQUIRED: "Servis Aral\u0131\u011F\u0131 Gereklidir",
  SERVICE_INTERVAL_NUMBER: "Servis Aral\u0131\u011F\u0131 Numaras\u0131",
  SERVICE_INTERVAL_STATUS: "Servis Aral\u0131\u011F\u0131 Durumu",
  SERVICE_INTERVAL_TYPE: "Servis aral\u0131\u011F\u0131 t\xFCr\xFC",
  SERVICE_INTERVAL_TYPES: "Servis Aral\u0131\u011F\u0131 T\xFCrleri",
  SERVICE_PART: "Servis par\xE7asi",
  SERVICE_UNAVAILABLE: "Servis Kullan\u0131lam\u0131yor",
  SERVICED: "Servis Uyguland\u0131",
  SERVICED_DATE_IS_REQUIRED: "Servis tarihi gerekli.",
  SERVICED_IS_REQUIRED: "Servis tarihi gerekli.",
  SET_AS_DEFAULT: "Varsay\u0131lan olarak ayarla",
  SETTINGS: "Ayarlar\u0131m",
  SETTLED: "\xC7\xF6z\xFCld\xFC",
  SETTLEMENT_NO_REGISTRATION: "\xC7\xF6z\xFCm No Kayd\u0131",
  SETUP: "Kurulum",
  SETUP_DATE_IS_REQUIRED: "Kurulum Tarihi gereklidir",
  SETUP_IS_REQUIRED: "Kurulum gereklidir",
  SGST_UTGST: "SGST/UTGST",
  SHIP_TO: "Sevk",
  SHIPPED: "Nakledildi",
  SHIPPING_INFORMATION_SPECIAL_INSTRUCTIONS: "Kargo Bilgileri/\xD6zel Talimatlar",
  SHIPPING_INSTRUCTIONS: "Nakliye Talimatlar\u0131",
  SHORT_TEXT: "K\u0131sa metin",
  SHORT_TEXT_IS_REQUIRED: "K\u0131sa Metin Gerekli",
  SHOW_ALL: "Hepsini G\xF6ster ({count})",
  SHOW_EXCLUDED: "Hari\xE7 B\u0131rak\u0131lan\u0131 G\xF6ster",
  SHOW_MORE: "Daha fazla g\xF6ster",
  SHOW_MORE_GROUPS: "{countToDisplay} grup daha g\xF6sterin",
  SHOW_RED_IF_LESS_THAN: "Daha Azsa K\u0131rm\u0131z\u0131 G\xF6ster",
  SHOW_REIMBURSED_AMOUNT: "Geri \xD6denen Tutar\u0131 G\xF6ster",
  SHOW_REIMBURSED_PERCENTAGE: "Geri \xD6denen Y\xFCzdesini G\xF6ster",
  SHOW_YELLOW_IF_LESS_THAN: "Daha Azsa Sar\u0131 G\xF6ster",
  SIGN_IN_REQUIRED: "Oturum a\xE7\u0131lmas\u0131 gerekiyor",
  SIGN_OUT: "Oturumu Kapat",
  SKIP_AUDIT: "Denetimi atla",
  SKIP_AUDIT_SUCCESS: "Denetim atland\u0131 ve vade tarihi art\u0131k ileride.",
  SOME_PARTS_RETURNED: "Baz\u0131 Par\xE7alar \u0130ade Edildi",
  SORT_BY: "S\u0131ralama \xD6l\xE7\xFCt\xFC",
  SPANISH: "\u0130spanyolca",
  SPECIAL_ALLOWANCE: "\xD6ZEL \xD6DENEK",
  SPECIAL_ALLOWANCE_CALCULATION: "\xD6zel Garanti Hesaplamas\u0131",
  SPECIAL_ALLOWANCE_CLAIM: "\xD6zel \xD6denek Talebi",
  SPECIAL_ALLOWANCE_CLAIM_STATUS: "\xD6zel \xD6denek Kleymi Durumu",
  SPECIAL_ALLOWANCE_CLAIM_STATUS_TABM: "\xD6zel \xD6denek Kleymi Durumu",
  SPECIAL_ALLOWANCE_CLAIM_STATUS_UPDATED: "\xD6zel \xD6denek Kleymi Durumu G\xFCncellendi",
  SPECIAL_ALLOWANCE_CLAIM_WITH_ID: "\xD6zel \xD6denek Kleymi - {claimNumber}",
  SPECIAL_ALLOWANCE_CLAIMS_WITH_COUNT: "\xD6zel \xD6denek Kleymi ({count})",
  SPECIAL_ALLOWANCE_CONTRIBUTIONS: "\xD6zel \xD6denek Katk\u0131lar\u0131",
  SPECIAL_ALLOWANCE_DESCRIPTION: "\xD6zel \xD6denek A\xE7\u0131klamas\u0131",
  SPECIAL_ALLOWANCE_TYPE: "\xD6zel Garanti T\xFCr\xFC",
  SPECIAL_ALLOWANCE_TYPE_IS_REQUIRED: "\xD6zel Garanti T\xFCr\xFC Gereklidir",
  SPECIAL_INSTRUCTIONS: "\xD6zel Talimatlar",
  SPG: "SPG",
  SPGS: "SPG'ler",
  STANDARD_VIEW: "Genel g\xF6r\xFCn\xFCm",
  START_AMOUNT_OF_USE: "Ba\u015Flang\u0131\xE7 Kullan\u0131m Miktar\u0131",
  STARTS: "Ba\u015Flang\u0131\xE7lar",
  STARTS_WITH: "Ba\u015Flamak",
  STATE: "Vilayet",
  STATE_PROVINCE: "Eyalet/\u0130l",
  STATE_PROVINCE_REQUIRED: "Eyalet/\u0130l Gerekli",
  STATUS: "Durum",
  STATUS_CHANGE_REQUEST: "Durum De\u011Fi\u015Fiklik \u0130ste\u011Fi",
  STATUS_CHANGE_REQUEST_CREATED_SUCCESSFULLY: "Durum de\u011Fi\u015Fiklik iste\u011Fi ba\u015Far\u0131yla olu\u015Fturuldu",
  STATUS_FOR: "{pin} i\xE7in durum",
  STATUS_INDICATOR: "Durum G\xF6stergesi",
  STATUS_REASON: "Durum Nedeni",
  STOLEN_DATE: "\xC7al\u0131nma Tarihi",
  STORE: "Depolama",
  STORE_IS_REQUIRED: "Depolama gereklidir",
  STORE_NUMBER_IS_REQUIRED: "Depolama Numaras\u0131 gereklidir",
  STREET_1: "Sokak 1",
  STREET_2: "Sokak 2",
  SUB: "G\xF6nder",
  SUB_CLAIM_TYPE: "Alt Kleym T\xFCr\xFC",
  SUB_TYPE: "Alt t\xFCr",
  SUBMISSION_DATE: "G\xF6nderme Tarihi",
  SUBMIT: "G\xF6nder",
  SUBMIT_AUDIT: "Denetimi G\xF6nder",
  SUBMIT_AUDIT_FOR: "{dealer} \u0130\xE7in Denetimi G\xF6nder",
  SUBMIT_FULL_DEBIT_CLAIM_FOR_WITH_CLAIM_NUMBER: "Tam Bor\xE7 Kleymini {claimNumber} i\xE7in G\xF6nder",
  SUBMIT_PARTIAL_DEBIT_CLAIM_FOR_WITH_CLAIM_NUMBER: "K\u0131smi Bor\xE7 Kleymini {claimNumber} i\xE7in G\xF6nder",
  SUBMIT_PERCENTAGE_DEBIT_CLAIM_FOR_WITH_CLAIM_NUMBER: "{claimNumber} i\xE7in Y\xFCzde Bor\xE7 Talebi G\xF6nder",
  SUBMIT_REQUEST: "Talebi G\xF6nder",
  SUBMITTED: "G\xD6NDER\u0130LD\u0130",
  SUBMITTED_AVAILABLE_TO_EDIT: "G\xD6NDER\u0130LD\u0130 (D\xFCzenlenebilir)",
  SUCCESS: "Ba\u015Far\u0131",
  SUCCESS_MESSAGE_TITLE: "Bir i\u015Flem ba\u015Far\u0131l\u0131yd\u0131:",
  SUCCESS_MESSAGES_TITLE: "Birden fazla i\u015Flem ba\u015Far\u0131l\u0131yd\u0131:",
  SUPPLIER_WARRANTY: "Tedarik\xE7i Garantisi",
  SURVEY_QUESTIONS: "Anket Sorular\u0131",
  SUSPENDED: "Ask\u0131ya Al\u0131nd\u0131",
  SWEDISH: "\u0130sve\xE7\xE7e",
  SYSTEM_SELECTED_CLAIMS: "Sistemin Se\xE7ti\u011Fi Kleymler",
  SYSTEM_SELECTED_CLAIMS_WITH_COUNT: "Sistemin Se\xE7ti\u011Fi Kleymler ({count})",
  TABM: "TABM",
  TAX: "Vergi",
  TCSM: "TCSM",
  TECH_ID: "Tek. Kiml.",
  TERMINATED: "Sonland\u0131r\u0131ld\u0131",
  TERMINATES: "Sonlan\u0131r",
  TERRITORY: "B\xF6lge",
  TEST: "Test",
  TEST_RESULTS_CODE: "Test Sonu\xE7lar\u0131 Kodu",
  THEME: "Tema",
  TIME_LIMIT: "S\xFCre Limiti",
  TIME_ZONE: "Zaman Dilimi",
  TITLE: "Ba\u015Fl\u0131k",
  TITLE_IS_REQUIRED: "Ba\u015Fl\u0131k Gerekli",
  TO: "Biti\u015F",
  TODAY: "Bug\xFCn",
  TOO_MANY_RESULTS: "\u0130ste\u011Finiz \xE7ok fazla sonu\xE7 d\xF6nd\xFCrd\xFC. L\xFCtfen arama terimlerinizi daralt\u0131n ve yeniden deneyin.",
  TOTAL: "Toplam",
  TOTAL_AMOUNT: "Toplam Tutar",
  TOTAL_APPROVED: "Onaylanan Toplam\u0131",
  TOTAL_APPROVED_CLAIM_VALUE: "Onaylanan Toplam Kleym Tutar\u0131",
  TOTAL_APPROVED_INCLUDING_TAXES: "Vergiler Dahil Toplam Onayland\u0131",
  TOTAL_APPROVED_WITHOUT_ADDITIVES: "Katk\u0131lar olmadan Onayl\u0131 Toplam",
  TOTAL_CONTRIBUTION: "Toplam Katk\u0131",
  TOTAL_REIMBURSED: "Geri \xD6denen Toplam",
  TOTAL_REIMBURSED_WITH_CURRENCY: "Geri \xD6denen Toplam\u0131 ({currency})",
  TOTAL_REQUESTED: "\u0130stenen Toplam\u0131",
  TOTAL_REQUESTED_CLAIM_VALUE: "\u0130stenen Toplam Kleym Tutar\u0131",
  TOTAL_UNPAID: "\xDCcretsiz Kalem Toplam\u0131",
  TRACKING_NUMBER: "Takip Numaras\u0131",
  TRANSFER: "Transfer",
  TRANSFER_APPROVALS: "Transfer Onaylar\u0131",
  TRANSFER_APPROVALS_TAB: "Transfer Onaylar\u0131 ({count})",
  TRANSFER_CREATED: "Transfer Olu\u015Fturuldu",
  TRANSFER_DEALER_RECOMMENDATIONS: "Pini ba\u015Fka bir sat\u0131c\u0131ya transfer etmek istedi\u011Finizden emin misiniz?",
  TRANSFER_UPDATED_SUCCESSFULLY: "Transfer ba\u015Far\u0131yla g\xFCncellendi",
  TRANSFERS: "Transferler",
  TRAVEL: "Nakliye",
  TURKISH: "T\xFCrk",
  TWO_PERCENT_WITHHOLD_VALUE: "% 2 al\u0131koymak De\u011Fer",
  TYPE: "T\xFCr",
  TYPES: "T\xFCrler",
  UNABLE_TO_CONTACT_THE_SERVER: "Sunucu ile ileti\u015Fim kurulam\u0131yor",
  UNABLE_TO_LOAD_CUSTOMER_DETAILS: "M\xFC\u015Fteri ayr\u0131nt\u0131lar\u0131 y\xFCklenemedi",
  UNDO: "Geri Al",
  UNDO_REGISTRATION: "Kayd\u0131 Geri Al",
  UNDO_REGISTRATION_SUCCESSFULL: "Kayd\u0131 Geri Al Ba\u015Far\u0131l\u0131",
  UNIT: "Birim",
  UNIT_1: "Birim 1",
  UNIT_2: "Birim 2",
  UNIT_3: "Birim 3",
  UNIT_OF_MEASURE: "\xD6l\xE7\xFC Birimi",
  UNPAID_LABOR: "\xDCcretsiz \u0130\u015F\xE7ilik",
  UNPAID_LABOR_ADDITIVES_EXCLUDING_PIPS: "\xD6denmemi\u015F \u0130\u015F\xE7ilik \u0130laveleri - PIP'ler Hari\xE7",
  UNPAID_LABOR_ADDITIVES_PIPS: "\xD6denmemi\u015F \u0130\u015F\xE7ilik \u0130laveleri - PIP'ler",
  UNPAID_OTHER_CREDITS: "Di\u011Fer \xDCcretsiz Alacaklar",
  UNPAID_PARTS: "\xDCcretsiz Par\xE7alar",
  UNPAID_PARTS_ADDITIVE: "\xD6denmemi\u015F Par\xE7alar \u0130lavesi",
  UNPAID_TRAVEL: "\xDCcretsiz Seyahat",
  UNSUB: "D\xFCzenle",
  UNSUBMIT_CLAIM: "D\xFCzenle Kleym",
  UPDATE_CUSTOMER_INFORMATION: "M\xFC\u015Fteri Bilgilerini G\xFCncelle",
  UPDATE_LABOR_RATES: "\u0130\u015F\xE7ilik \xDCcretlerini G\xFCncelle",
  UPDATE_LAYOUT: "Mizanpaj G\xFCncelle",
  UPDATE_MACHINE_STATUS: "Makine Durumunu G\xFCncelle",
  UPDATE_MACHINE_STATUS_HISTORY: "Makine Durumunu G\xFCncelleme Ge\xE7mi\u015Fi",
  UPDATE_REGISTRATION: "Kayd\u0131 G\xFCncelle\u015Ftir",
  UPDATE_SELECTED: "Se\xE7ileni G\xFCncelle\u015Ftir",
  UPDATED: "G\xFCncellendi",
  UPDATED_BY: "Taraf\u0131ndan g\xFCncellendi",
  UPLOAD_DOCUMENT: "Belge Y\xFCkle",
  UPTIME_ASSURANCE: "\xC7al\u0131\u015Fma S\xFCresi G\xFCvencesi",
  USEFUL_LINKS: "Faydal\u0131 Ba\u011Flant\u0131lar",
  USER: "kullan\u0131c\u0131",
  USER_PREFERENCES_UPDATED: "Kullan\u0131c\u0131 tercihleri g\xFCncellendi",
  USER_SELECTED: "Kullan\u0131c\u0131n\u0131n Se\xE7ti\u011Fi",
  USER_SELECTED_CLAIMS_WITH_COUNT: "Kullan\u0131c\u0131n\u0131n Se\xE7ti\u011Fi Kleym ({count})",
  USERS_INFORMATION: "Kullan\u0131c\u0131 Bilgileri",
  VALIDATE: "Do\u011Frula",
  VALIDATE_CLAIM: "Talebi Do\u011Frula",
  VALUE: "De\u011Fer",
  VALUE_OF_REPAIR: "Onar\u0131m De\u011Feri",
  VIEW_CLAIM: "Kleymi G\xF6r\xFCnt\xFCle",
  VIEW_DETAILS: "Ayr\u0131nt\u0131lar\u0131 G\xF6r\xFCnt\xFCle",
  VIEW_OPEN_PIPS: "A\xE7\u0131k PIP'leri G\xF6r\xFCnt\xFCle",
  VIEW_PIP: "PIP'i G\xF6r\xFCnt\xFCle",
  VIEW_PRODUCTS: "\xDCr\xFCnleri G\xF6r\xFCnt\xFCle",
  VIEW_PRODUCTS_AND_UPDATE_INFO: "\xDCr\xFCnleri G\xF6r\xFCnt\xFCle ve G\xFCncelleme Bilgileri",
  VIEW_UPDATE: "G\xF6r\xFCnt\xFCle/G\xFCncelle",
  VSR_MESSAGES: "VSR Mesajlar\u0131",
  WAITING_FOR_DLR_INV: "Bayi Faturas\u0131 Bekliyor",
  WAITING_FOR_INVOICE: "Fatura Bekleniyor ({count})",
  WAITING_SINCE: "Bekleme S\xFCresi",
  WARNING_MESSAGE_TITLE: "Bir uyar\u0131 g\xF6nderildi:",
  WARNING_MESSAGES: "Uyar\u0131 Mesajlar\u0131",
  WARNING_MESSAGES_TITLE: "Birden fazla uyar\u0131 g\xF6nderildi:",
  WARRANTY: "Garanti",
  WARRANTY_ADMIN: "Garanti Y\xF6neticisi",
  WARRANTY_CLAIM_TYPE: "Garanti Talep T\xFCr\xFC",
  WARRANTY_COVERAGE: "Garanti Kapsam\u0131",
  WARRANTY_EXPIRATION: "Garanti S\xFCre Sonu",
  WARRANTY_TYPE: "Garanti T\xFCr\xFC",
  WARRANTY_TYPES: "Garanti T\xFCrleri",
  WEAR_PARTS: "Par\xE7a Takma",
  WEAR_PARTS_COVERAGE: "Par\xE7a Kapsam\u0131",
  WELCOME: "Ho\u015F Geldiniz",
  WIP: "\u0130\u015F Devam Ediyor",
  WITH_ADDITIVES: "\u0130laveler \u0130le",
  WITNESS_FIRST_NAME: "\u015Eahit Ad\u0131",
  WITNESS_LAST_NAME: "\u015Eahit Soyad\u0131",
  WORK_ORDER: "\u0130\u015F Emri",
  WORK_ORDER_NUMBER: "\u0130\u015F Emri Numaras\u0131",
  WORK_ORDER_ONE: "\u0130\u015F Emri 1",
  WORK_ORDER_ONE_IS_REQUIRED: "\u0130\u015F Emri 1 gereklidir",
  WORK_ORDER_THREE: "\u0130\u015F Emri 3",
  WORK_ORDER_THREE_IS_REQUIRED: "\u0130\u015F Emri 3 gereklidir",
  WORK_ORDER_TWO: "\u0130\u015F Emri 2",
  WORK_REPAIR_ORDER: "\u0130\u015F Tamir Sipari\u015Fi",
  YES: "Evet",
  YES_LOWERCASE: "Evet"
});